import {
    Component, OnInit, 
    ViewContainerRef,
    ElementRef, ViewChild
} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { AppService } from '../../../app.service';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem, EquipmentDetailsParams } from '../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { SetupImplementService } from './setup-implement.service';
import { EquipmentService } from '../services/equipment.service';
import {
    TemplateViewModel,
    GenericIdName,
    ImplementDetails,
    MeasurementPointDetails,
    ObservationPointDetails,
    SaveImplementImageParams,
    SchematicDataVM,
    ComponentVM,
    ApplySelectionData,
    SaveImplementDetailParams,
    SaveMeasurementPointParams,
    SaveObservationPointParams,
    SaveComponentParams,
    SetupImplementPageConstants,
    SetupImplementErrorCodes,
    SaveModeltParams,
    SchematicImagesVM,
    saveNewImplementTypeVM,
    ValidationErrorStatus,
    SchematicUploadParams,
    SaveQuestionImageParams,
    ObservationPointVMEdit
} from './setup-implement.model';
import { ModelSelected } from '../entities/global/model';
import { NewImplementTemplate } from '../entities/implement-template.model';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../adapters/ordinal-date-adapter';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { GETDeleteConfirmationDialogComponent } from './delete-confirmation-dialog/delete-confirmation-dialog.component';
import { CopyImplementDialogComponent } from './copy-implement-dialog/copy-implement-dialog.component';
import { UpdateObservationPointModal } from '../add-observation-point/add-observation-point-modal';
import { EquipmentDetailsService } from '../equipment-details/equipment-details.service';
import { SelectionNewImplementComponent } from './add-new-componentType/add-new-componentType.component';
import { FamilyList, ModelSelectionFilter } from '../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { NotificationsService } from 'angular2-notifications';
import { SchematicViewService } from '../schematic-view/schematic-view.service';
import { SchemanticOpPopupEditComponent } from '../schemantic-op-popup-edit/schemantic-op-popup-edit.component';
import { componentListsVM } from '../equipment-details/equipment-details.model';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { heicTo } from 'heic-to';

@Component({
    selector: 'setup-implement',
    templateUrl: './setup-implement.component.html',
    styleUrls: ['./setup-implement.component.scss'],
    animations: [
        trigger(
            'fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 0 }),
                animate('0ms', style({ opacity: 0 }))
            ])
        ]
        )],
    providers: [
        {
            provide: DateAdapter, useClass: OrdinalDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
        }
    ]
})
export class SetupImplementComponent implements OnInit {
    private _subscriptions: Subscription[] = [];
    private _equipmentId: number;
    private _implementId: number;
    oldGetUrl: string;
    setupComplete: boolean = false;
    isLinear: boolean = true;
    currentStep: number = 0;
    IsTemplate:boolean=false;
    // Image uploaders
    @ViewChild('uploadImplementImage') ImplementImageUpload: ElementRef;
    @ViewChild('uploadSchematicImage') SchematicImageUpload: ElementRef;

    // Page constants
    pageConstants: SetupImplementPageConstants = new SetupImplementPageConstants();

    // Error codes
    pageErrors: SetupImplementErrorCodes = new SetupImplementErrorCodes();

    // Radio buttons
    newOrExistingOption: string = this.pageConstants.IMPLEMENT_SETUP_NEW;
    equipmentOrInventory: string = this.pageConstants.SETUP_ON_EQUIPMENT;

    // Models
    modelList_:GenericIdName[]=[];
    modelList: ModelSelected[] = [];
    modelListFiltered: ModelSelected[];
    modelListFilter: string;
    selectedModels: number[] = [];
    implementTemplateDetails: NewImplementTemplate;

    // Component Types
    componentList: ComponentVM[] = [];
    componentListFiltered: ComponentVM[];
    componentListFilter: string;
    selectedComponentsList: ComponentVM[] = [];
    newComponentName: string;
    newComponentMakeId: number;
    newComponentPartNo: string;
    newComponentCusPartNo: string;

    newComponentId: number = 1;
    newComponentCritical:boolean=true;
    isGETCritical:boolean
    cbAllComponentsSelect: boolean = true;
    cbAllObservationSelect: boolean = false;
    newComponentTypeId: number;
    newcompBudgetLife:number=2000;

    // Save component - unsaved changes warning.
    unsavedChanges_ComponentSetup: boolean = false;
    unsavedChanges_OPSetup: boolean = false;
    unsavedChanges_ModelSetup: boolean = false;

    // Observation Point Types
    observationPointTypes: GenericIdName[] = [];
    observationPointListFilter: string;

    // Model loading Finished
    modelsLoaded: boolean = false;

    // Filter by selected or unselected.
    hideSelectedModels: boolean = false;
    hideUnselectedModels: boolean = false;
    hideSelectedMPs: boolean = false;
    hideUnselectedMPs: boolean = false;
    hideSelectedOPs: boolean = false;
    hideUnselectedOPs: boolean = false;

    // Step 1
    customerList: CustomerSelectItem[] = [];
    jobsiteList: JobsiteSelectItem[] = [];
    equipmentList: EquipmentSelectItem[] = [];
    NewimplementType: string
    NewImplementImage: string = ""
    isNewImplement: boolean = false
    // User selections in input boxes
    selectedCustomer: number = 0;
    selectedJobsite: number = 0;
    selectedEquipment: number = 0;
    selectedMake: number = 0;
    selectedImplementType: number = 0;
    selectedImplement: number = 0;
    selectedSchematic: SchematicDataVM;
    selectedSchematicEdit: ObservationPointVMEdit
    selectedSchematicEdit_: SchematicDataVM[]
    NewSchematicId: number = 1;
    budgetHrs: number;
    bcmHrs: number;
    tonHrs: number;
    
    purchaseCost: number;
    // Preserve implement id, which gets lost after navigating away from the tab.
    attachedImplementSelected: number = this.selectedImplement;

    // Preserve previously selected implement type.
    prevSelectedImplementType: number = 0;

    // Step 2
    implementList: GenericIdName[] = [];
    implementTypeList: TemplateViewModel[] = [];
    makeList: GenericIdName[] = [];
    serialNumber: string = '';
    canChangeHoursAndDate: boolean = true;
    dateOfReading: Date = new Date();
    implementHours: number = 0;
    equipmentSMU: number = 0;
    Additional_serial_num: string = null;
    bucketCapacity:number;
    selectedGETType:number;
    implementImage: string = '';
    schematicList: SchematicDataVM[] = [];

    // Step 3
    //componentList: MeasurementPointDetails[] = [];
    observationLists: GenericIdName[] = [];
    observationPoints: ObservationPointDetails[] = [];
    observationListFiltered: ObservationPointDetails[] = []
    selectedObservationList: ObservationPointDetails[] = [];

    newOPName: string = "";
    newOPObservationListId: number = 0;
    newOPLimitNew: number = 0;
    newOPLimitScrap: number = 0;

    observationListFilter: string;
    observationListAfterChanages: ObservationPointDetails[]
    isvalidStep3: boolean = true


    // Right-click Context Menu
    showContextMenu: boolean = false;
    contextMenuX: string = "100px";
    contextMenuY: string = "100px";
    selectionData: ApplySelectionData = new ApplySelectionData();

    // Highlight for vacant or all cells, for the right-click context menu.
    showVacantCells: boolean = false;
    showAllCells: boolean = false;

    // Schematic window.
    showSchematic: boolean = false;
    schematicPositionX: number;
    schematicPositionY: number;
    draggableSchematicTitle: string = "Schematic";
    showObservation: boolean = true;

    // Pre-populate Make for Measurement Points of new Implement with the Equipment / Implement Make.
    prepopulateMake: number = 0;

    // Mouse events for draggable schematic window.
    isMouseDown: boolean = false;
    prevMouseX: number;
    prevMouseY: number;

    // Mouse-over highlight components and observation points.
    mouseoverMPId: number = 0;
    mouseoverOPId: number = 0;

    // Mouse-over highlight implement type replicate icon
    mouseoverITReplicate: boolean = false;

    observationListId: any;

    //tab3validation variables
    observationPointsOld: ObservationPointDetails[]
    cbApplyToAll: boolean = false
    cbApplyToOne: boolean = false
    AllChecked
    OneChecked
    public selectedIds: any
    public selectedId: any
    public array: any
    public haschanges: Boolean
    onlyInA: any

    //getSchematic Image name
    selectedSechamnticImage: File
    SelectedschematicImageList: SchematicImagesVM = new SchematicImagesVM();
    Imagelist: SchematicDataVM[] = []

    equipmentDetails: EquipmentDetailsParams;

    componentTypeList: GenericIdName[] = [];

    //tab4
    selectedMakeList: number[] = [];
    familyList: FamilyList[] = [];
    selectedFamilyList: number[] = [];

    selectedFamily:number[]=[];
    selectedMakes:number[]=[];
    target: any[] = [];
    source: any[] = [];
    componentId: number;

    
  NewMaxCrackLength:number=0
  colorCodeList:componentListsVM[]
  NewcolorCode:number=0
  SeverityList:componentListsVM[]
  Newseverity:number=0
  NewUOM:number=1
    constructor(private _appService: AppService,
        private _setupEquipmentService: GETSetupEquipmentService,
        private _implementService: SetupImplementService,
        private _route: ActivatedRoute, private _router: Router,
        private _sanitizer: DomSanitizer, private _snackBar: MatSnackBar,
        private _equipmentService: EquipmentService,
        public dialog: MatDialog, 
        private toastr: NotificationsService,
         vcr: ViewContainerRef,
        public _equipmentDetailsService: EquipmentDetailsService,
        public _favouriteDialogService: FavouriteDialogService, public _dualList: AngularDualListBoxModule,
        public SchematicViewService_:SchematicViewService) {


    }

    ismodified: boolean = false;
    title:string="";
    ngOnInit() {

       // this._appService.setPageSubTitle(this.pageConstants.PAGE_SUBTITLE);
        //this._implementId = this._route.snapshot.params.id;
        this._equipmentId = this._route.snapshot.params.id;

this._route.params.subscribe(params => {
            this.selectedImplement = +params['implementId'];

            if (this.selectedImplement) {
               // this.initialise();
            }
        });
        if (this._equipmentId != null) {
            this.loadEquipmentDetails(1);

            // GET-262
            this.selectedEquipment = this._equipmentId;
            this.loadImplementTypes();
        }
        this.LoadModels();
        var implementSetupPath = this._route.snapshot.routeConfig.path;
        if (implementSetupPath != null) {
            if ((implementSetupPath == 'setup/implement') || (implementSetupPath == 'setup/implement/:implementId')) {
                this.newOrExistingOption = this.pageConstants.IMPLEMENT_SETUP_NEW;
                this._appService.setPageTitle(this.pageConstants.PAGE_TITLE);
                this.title=this.pageConstants.PAGE_TITLE;
            } else {
                this.newOrExistingOption = this.pageConstants.IMPLEMENT_SETUP_EXISTING;
                this._appService.setPageTitle(this.pageConstants.PAGE_TITLE_MODIFY);
                this.ismodified = true;
                this.title=this.pageConstants.PAGE_TITLE_MODIFY;
            }
        }

        if (this._implementId != null) {
            this.loadStepOne();
        } else {
            this.loadStepOne();
        }
        // this._appService.returnBrandedGETHost().subscribe(getUrl => {
        //     this.oldGetUrl = getUrl;
        // });

        this.getColorCodes();
    }



    loadEquipmentDetails(value: number) {
        this._equipmentDetailsService.getEquipmentDetails(this._equipmentId).subscribe(equipment => {
            this.equipmentDetails = equipment;

            if (value == 1) {
                this.selectedCustomer = this.equipmentDetails.CustomerId;
                this.loadJobsitesForCustomer();
                this.selectedJobsite = this.equipmentDetails.JobsiteId;
                this.loadEquipmentForJobsite();
                this.selectedEquipment = this._equipmentId;
            }
            if (value = 0) {

            }



            this.loadModelList();
        });

    }
    // Models
    onModelListControlChanged(id) {
        var mt = this.modelList.find(m => m.Id == id);
        if (mt != null) {
            mt.Selected = !mt.Selected;
        }

        this.selectedModels = this.modelList.filter(m => m.Selected).map(item => item.Id);
    }
    onModelListFilterChange() {
        this.modelListFiltered = this.modelList.filter(item => item.Name.toLowerCase().includes(this.modelListFilter.toLowerCase()) ? true : false)
    }

    //Observation
    onObservationNameFilterChange() {
        if (this.observationListFilter != null && this.observationListFilter.length > 0) {
            this.observationListFiltered = this.observationPoints.filter(item => item.Name != null && item.Name.toLowerCase().includes(this.observationListFilter.toLowerCase()) ? true : false)
        } else {
            this.observationListFiltered = this.observationPoints;
        }
    }

    onObservationListControlChanged(id, name) {
        var ct = this.observationPoints.find(ct => ct.Id == id && ct.Name == name);
        if (ct != null) {
            ct.Selected = !ct.Selected;
        }

        this.selectedObservationList = this.observationPoints.filter(c => c.Selected).map(item => {
            let op: ObservationPointDetails = {
                Id: item.Id,
                Name: item.Name,
                ObservationPointType: item.ObservationPointType ? item.ObservationPointType : 0,
                ObservationListIds: item.ObservationListIds ? item.ObservationListIds : [],
                ObservationListId: item.ObservationListId,
                Selected: item.Selected,
                NumberOfReadings: item.NumberOfReadings,
                LimitNew: item.LimitNew,
                LimitScrap: item.LimitScrap,
                ComponentName: item.ComponentName,
                ComponentMake: item.ComponentMake,
                ComponentPartNo: item.ComponentPartNo,
                ComponentId: item.ComponentId,
                Active: item.Active,
                QuestionImage: item.QuestionImage,
                QuestionImagePath: item.QuestionImagePath,
                IsNewImage: item.IsNewImage,
                QName:item.QName,
                QDesc:item.QDesc,
                LimitRange:item.LimitRange,
                Measurement:item.Measurement,
                InspectionDate:item.InspectionDate,
                //SchmeticName:item.SchmeticName,
                SortOrder:item.SortOrder,
                InspectionTypeID:item.InspectionTypeID,
                IsAnswer:item.IsAnswer,
                IsImage:item.IsImage,
                Xcoord:item.Xcoord,
                Ycoord:item.Ycoord,
                EndXcoord:item.EndXcoord,
                EndYcoord:item.EndYcoord,
                ComponentType:item.ComponentType,
                ComponentTypeId : item.ComponentTypeId,
                ComponentTypeSortOrder: item.ComponentTypeSortOrder,
                CrackSeverityListId: item.CrackSeverityListId
            }
            return op;
        });
    }
    // Components
    onComponentListControlChanged(id, name) {
        var ct = this.componentList.find(ct => ct.Id == id && ct.Name == name);
        if (ct != null) {
            ct.Selected = !ct.Selected;
        }

        this.selectedComponentsList = this.componentList.filter(c => c.Selected).map(item => {
            var comp = new ComponentVM();

comp.Id = item.Id;
comp.SchematicName = item.SchematicName;
comp.SchematicId = item.SchematicId;
comp.Name = item.Name;
comp.MakeId = item.MakeId ? item.MakeId : 0;
comp.PartNo = item.PartNo ? item.PartNo : "";
comp.CusPartNo = item.CusPartNo ? item.CusPartNo : "";

comp.Selected = item.Selected;
comp.IsNew = item.IsNew;
comp.SortOrder = item.SortOrder;
comp.CompTypeId = item.CompTypeId;
comp.IsCritical = item.IsCritical;
comp.CompBudgetLife = item.CompBudgetLife;
comp.isGETCritical = item.isGETCritical;

comp.ActionId = 0;
comp.comment = "";
comp.cost = 0;
comp.selectComp = false;
comp.ActionSucess = 1;
comp.Error = "";
comp.ActionMinDate = null;
comp.hasObPoint = false;

comp.ColorCodeID = item.ColorCodeID;
comp.MaxCrackLength = item.MaxCrackLength;
comp.UOM = item.UOM;
comp.severityType = item.severityType;

comp.PartCost = 0;
comp.MiscCost = 0;
comp.LabourCost = 0;
comp.LabourHrs = 0;

comp.CompTypeSort = 1;
comp.MakeName = '';
comp.Planned = false;

            return comp;
        });
    }

    onComponentListFilterChange() {
        if (this.componentListFilter != null && this.componentListFilter.length > 0) {
            this.componentListFiltered = this.componentList.filter(item => item.Name != null && item.Name.toLowerCase().includes(this.componentListFilter.toLowerCase()) ? true : false)
        } else {
            this.componentListFiltered = this.componentList;
        }
    }


    onComponentCriticalChange(event,compId:number,Component:ComponentVM){
        console.log("Crirtical checked",compId,Component.IsCritical)
        if(event.checked==true && Component.isGETCritical==true )
        {
            
            Component.isGETCritical=false
        }
        return Component.IsCritical = !Component.IsCritical;

    }

    onGETComponentCriticalChange(event,compId:number,Component:ComponentVM){
        console.log("Crirtical checked",compId,Component.isGETCritical)
        if(event.checked==true && Component.IsCritical==true ){
           
            Component.IsCritical=false
        }
        return Component.isGETCritical = !Component.isGETCritical;

    }
    //onGETComponentCriticalChange
    //add new component Type

    addNewComponentType() {
        const dialogRef = this.dialog.open(SelectionNewImplementComponent, {
            panelClass: 'removeModalOverflow',
            data: {
                ImplementId: this.selectedImplement,
                isCompType:true,
            }
        });

        dialogRef.afterClosed().subscribe(newJobsiteName => {
            this.loadComponentTypes();
        });
    }
    addNewComponent(scrollTarget) {
        if ((this.newComponentName === undefined) || (this.newComponentName.trim().length < 1)) {
            this.toastr.error(this.pageErrors.ERROR_COMPONENT_NAME_MISSING_2);
            return;
        }

        // if ((this.newComponentPartNo === undefined) || (this.newComponentPartNo.trim().length < 1)) {
        //     this.toastr.error(this.pageErrors.ERROR_COMPONENT_PART_MISSING_2);
        //     return;
        // }

        // if ((this.newComponentMakeId === undefined) || (this.newComponentMakeId == 0)) {
        //     this.toastr.error(this.pageErrors.ERROR_COMPONENT_MAKE_MISSING_2);
        //     return;
        // }
        if(this.equipmentOrInventory=='3'){
            if ((this.newComponentTypeId === undefined) || (this.newComponentMakeId == 0)) {
                this.toastr.error(this.pageErrors.ERROR_COMPONENT_TYPE_MISSING_2);
                return;
            }
        }
        
        if ((this.componentList != null)
            && (this.componentList.filter(cl => cl.Name != null && cl.Name.toLowerCase() == this.newComponentName.toLowerCase()).length > 0)) {
            this._snackBar.open('This component type already exists!', null, {
                duration: 1000,
            });
        } else {
            var newComponent = new ComponentVM();

newComponent.Id = this.newComponentId;
newComponent.SchematicName = "";
newComponent.SchematicId = 0;
newComponent.Name = this.newComponentName;
newComponent.MakeId = this.newComponentMakeId;
newComponent.PartNo = this.newComponentPartNo;
newComponent.CusPartNo = this.newComponentCusPartNo;

newComponent.Selected = true;
newComponent.IsNew = true;
newComponent.SortOrder = this.componentList.length;
newComponent.CompTypeId = this.newComponentTypeId;
newComponent.IsCritical = this.newComponentCritical;
newComponent.CompBudgetLife = this.newcompBudgetLife;
newComponent.isGETCritical = this.isGETCritical;

newComponent.ActionId = 0;
newComponent.comment = "";
newComponent.cost = 0;
newComponent.selectComp = false;
newComponent.ActionSucess = 1;
newComponent.Error = "";
newComponent.ActionMinDate = null;
newComponent.hasObPoint = false;

newComponent.ColorCodeID = this.NewcolorCode;
newComponent.MaxCrackLength = this.NewMaxCrackLength;
newComponent.UOM = this.NewUOM;
newComponent.severityType = this.Newseverity;

newComponent.PartCost = 0;
newComponent.MiscCost = 0;
newComponent.LabourCost = 0;
newComponent.LabourHrs = 0;

newComponent.CompTypeSort = 1;
newComponent.MakeName = '';
newComponent.Planned = false;

            this.componentList.push(newComponent);
            this.componentListFilter = '';
            this.componentListFiltered = this.componentList;
            scrollTarget.scrollIntoView({ behavior: "smooth" });
            this.newComponentId++;
            this.newComponentName = '';
            this.newComponentMakeId = 0;
            this.newComponentPartNo = '';
            this.newComponentTypeId = 0;
            this.selectedComponentsList.push(newComponent);
        }
    }

    deleteNewComponent(id) {
        this.componentList = this.componentList.filter(f => !(f.Id == id && f.IsNew == true));
        this.selectedComponentsList = this.selectedComponentsList.filter(f => !(f.Id == id && f.IsNew == true));
        this.initialiseSortOrder();
        this.componentListFiltered = this.componentList;
    }

    initialiseSortOrder() {
        for (var i = 0; i < this.componentList.length; i++) {
            this.componentList[i].SortOrder = i;
        }
    }

    recalculateSortOrder(id, isDown, isNew) {
        for (var i = 0; i < this.componentList.length; i++) {
            // Not the entry that was clicked upon.
            if (this.componentList[i].Id != id) {
                continue;
            }
            // Found the item that was selected.
            else {
                // First item and sort position decreased.
                if ((i == 0) && !isDown) {
                    // DO NOTHING
                    //this.componentList[i].SortOrder = 0;
                }
                // Last item and sort position increased.
                else if ((i == this.componentList.length - 1) && isDown) {
                    // DO NOTHING
                    //this.componentList[i].SortOrder = this.componentList.length - 1;
                }
                // Increase sort position
                else if ((i >= 0) && isDown && (i < this.componentList.length - 1)) {
                    var pos = this.componentList[i + 1].SortOrder;
                    this.componentList[i + 1].SortOrder = this.componentList[i].SortOrder;
                    this.componentList[i].SortOrder = pos;
                }
                // Decrease sort position
                else if ((i < this.componentList.length) && !isDown && (i > 0)) {
                    var pos = this.componentList[i - 1].SortOrder;
                    this.componentList[i - 1].SortOrder = this.componentList[i].SortOrder;
                    this.componentList[i].SortOrder = pos;
                }
            }
        }

        this.componentList.sort((s, t) => {
            if (s.SortOrder > t.SortOrder) {
                return 1;
            }

            if (s.SortOrder < t.SortOrder) {
                return -1;
            }

            return 0;
        });

        this.onComponentListFilterChange();
    }

    isFirstComponentInList(id) {
        if (this.componentList.find(f => f.Id == id).SortOrder == 0) {
            return true;
        }
        return false;
    }

    isLastComponentInList(id) {
        if (this.componentList.find(f => f.Id == id).SortOrder == this.componentList.length - 1) {
            return true;
        }
        return false;
    }

    getMakeById(id) {
        if (this.makeList != null && this.makeList.length > 0) {
            var makeDesc = this.makeList.find(w => w.Id == id);
            if (makeDesc != null) {
                return makeDesc.Name;
            }
            return "";
        }
        return "";
    }

    // Toggle filters
    toggleSelectedModels() {
        this.hideSelectedModels = !this.hideSelectedModels;
    }

    toggleUnselectedModels() {
        this.hideUnselectedModels = !this.hideUnselectedModels;
    }

    toggleAllComponents(v) {
        this.componentList.forEach(c => c.Selected = v);
        this.componentListFiltered.forEach(c2 => c2.Selected = v);
    }

    toggleSelectedMPs() {
        this.hideSelectedMPs = !this.hideSelectedMPs;
    }

    toggleUnselectedMPs() {
        this.hideUnselectedMPs = !this.hideUnselectedMPs;
    }

    toggleSelectedOPs() {
        this.hideSelectedOPs = !this.hideSelectedOPs;
    }

    toggleUnselectedOPs() {
        this.hideUnselectedOPs = !this.hideUnselectedOPs;
    }

    toggleAllObsevations(v) {
        this.observationPoints.forEach(c => c.Selected = v);
        this.observationListFiltered.forEach(c2 => c2.Selected = v);
    }

    selectionLogicForModels(isSelected: boolean): boolean {
        if ((!this.hideSelectedModels && !this.hideUnselectedModels)
            || (!this.hideSelectedModels && isSelected && this.hideUnselectedModels)
            || (!this.hideUnselectedModels && !isSelected && this.hideSelectedModels)) {
            return true;
        } else {
            return false;
        }
    }

    selectionLogicForMPs(isSelected: boolean): boolean {
        if ((!this.hideSelectedMPs && !this.hideUnselectedMPs)
            || (!this.hideSelectedMPs && isSelected && this.hideUnselectedMPs)
            || (!this.hideUnselectedMPs && !isSelected && this.hideSelectedMPs)) {
            return true;
        } else {
            return false;
        }
    }

    selectionLogicForOPs(isSelected: boolean): boolean {
        if ((!this.hideSelectedOPs && !this.hideUnselectedOPs)
            || (!this.hideSelectedOPs && isSelected && this.hideUnselectedOPs)
            || (!this.hideUnselectedOPs && !isSelected && this.hideSelectedOPs)) {
            return true;
        } else {
            return false;
        }
    }

    preLoadComponentTypesSelected() {
        // Component type list
        if (this.implementTemplateDetails.ComponentTypes != null) {

            for (var i = 0; i < this.implementTemplateDetails.ComponentTypes.length; i++) {
                // Add to the list of selected component types
                var newImplementComponentType = new ComponentVM();
                newImplementComponentType.Id = this.implementTemplateDetails.ComponentTypes[i].Id;
                newImplementComponentType.Name = this.implementTemplateDetails.ComponentTypes[i].Name;
                newImplementComponentType.Selected = true;
                this.selectedComponentsList.push(newImplementComponentType);

                // Mark the selected components in the filtered list.
                for (var j = 0; j < this.componentListFiltered.length; j++) {
                    if (this.componentListFiltered[j].Id == this.implementTemplateDetails.ComponentTypes[i].Id) {
                        this.componentListFiltered[j].Selected = true;
                        break;
                    }
                }
            }
        }
    }
    equipmentmodel: GenericIdName;
    loadModelList() {
        // Need to get the models first before loading selections.
        this._equipmentService.getModelList().subscribe(result => {
            this.modelList = result;
            this.modelListFiltered = result;
            this.modelsLoaded = true;
            console.log(this.equipmentDetails, "eqDEtails")
            if (this.equipmentDetails != null) {
                this.equipmentmodel = this.modelList.find(x => x.Name == this.equipmentDetails.Model);
                console.log("model selected", this.equipmentmodel)


            }


        });

    }
    OldObservationPoints: ObservationPointDetails[];
    loadOLDObservationPointsForImplement() {
        this._subscriptions.push(this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
            this.OldObservationPoints = r;
        }));
    }
    OldComponentList: ComponentVM[];
    loadOldGETComponents() {
        this._implementService.ReturnGETComponents(this.selectedImplement).subscribe(result => {
            this.OldComponentList = result;
        });
    }


    loadGETComponents() {
        this._implementService.ReturnGETComponents(this.selectedImplement).subscribe(result => {
            this.componentList = result;
            this.OldComponentList = result;
            this.componentListFiltered = result;
            this.selectedComponentsList = [];

            //this.preLoadComponentsSelected();
            this.initialiseSortOrder();

        });
    }

    // Start by loading the Customer list
    loadStepOne() {
        this._subscriptions.push(this._setupEquipmentService.getCustomerList().subscribe(r => {
            this.customerList = r;
            

            // Then load equipment models for that customer.
            this.loadModelList();
            // Load make list
            this.loadMakes();
            this.loadAvailableModelList();
            this._favouriteDialogService.getFamilyList();

        }));
    }



    // Show the list of Jobsites for the selected customer.
    // Also loads the observation lists.
    loadJobsitesForCustomer() {
        if (this.selectedCustomer == null)
            return;
        this.selectedJobsite = null;
        this.jobsiteList = [];
        this.selectedEquipment = null;
        this.equipmentList = [];
        this._subscriptions.push(this._setupEquipmentService.getJobsiteList(this.selectedCustomer).subscribe(r => {
            this.jobsiteList = r;
        }));
        this.loadObservationLists();
    }

    // If the implement is selected as being on an equipment,
    // show the list of equipment for that jobsite.
    loadEquipmentForJobsite() {
        if (this.selectedJobsite == null)
            return;
        this._subscriptions.push(this._setupEquipmentService.getEquipmentList(this.selectedJobsite).subscribe(r => {
            this.equipmentList = r;
        }));

        // Ensure that implements are still loaded even if the jobsite is selected last.
        if (this.equipmentOrInventory == this.pageConstants.SETUP_IN_INVENTORY) {
            this.createInInventory();
        }
    }

    loradtarget: GenericIdName[] = [];
    // Supported equipment models
    loadSupportEquipmentModels() {
        this.selectedModels = null;
        if (this.ismodified) {
            this._implementService.LoadSelectedModelsForImplementtType(this.selectedImplementType).subscribe(r => {
                if (r != null) {
                    this.selectedModels = r.m_Item2.modelList;
                    //console.log("selected models", this.selectedModels)
                    //4444console.log("Available models", this.source)
                    if (this.source.length > 0) {
                        this.selectedModels.map(item => {
                            this.source.forEach(element => {
                                if (element.Id == item) {

                                    console.log(element.Id, item)
                                    let value = new GenericIdName();
                                    value.Id = element.Id;
                                    value.Name = element.Name;
                                    this.loradtarget.push(value);
                                    //this.source = this.source.filter(i=>i.Id != item);
                                }
                            });

                        });

                        this.target = this.loradtarget;
                    }

                    console.log(this.target, this.source)
                    this.loadAvailableModelList();
                    //previous code
                    // for (var i = 0; i < this.modelListFiltered.length; i++) {
                    //     for (var j = 0; j < this.selectedModels.length; j++) {
                    //         if (this.modelListFiltered[i].Id == this.selectedModels[j]) {
                    //             this.modelListFiltered[i].Selected = true;
                    //             break;
                    //         }
                    //         else {
                    //             this.modelListFiltered[i].Selected = false;
                    //         }

                    //     }
                    // }
                }
            });
        }

    }


    //add new Implement Type

    addNewImplementType() {
        const dialogRef = this.dialog.open(SelectionNewImplementComponent, {
            panelClass: 'removeModalOverflow',
            data: {
                selectedCustomer: this.selectedCustomer,
                isImpType:true,
            }
        });

        dialogRef.afterClosed().subscribe(newJobsiteName => {
           
            this._subscriptions.push(this._implementService.GetTemplateListForUserFilterByCustomer(this.selectedCustomer).subscribe(r => {
                console.log("GetTemplateListForUserFilterByCustomer", r)
    
                this.implementTypeList = r;
            }));
            
        });
    }

    EditImplementSerial(impId:number) {
        const dialogRef = this.dialog.open(SelectionNewImplementComponent, {
            panelClass: 'removeModalOverflow',
            data: {
                implementSerial: this.implementList.find(x=>x.Id==this.selectedImplement).Name.split(':')[1],
                isImplement:true,
                ImplementId:this.selectedImplement
            }
        });

        dialogRef.afterClosed().subscribe(r => {
           
            this.loadImplementsForEquipment();
            this.selectedImplement = impId;
            this.serialNumber =  r;
            
        });
    }

    // Implement Makes
    loadMakes() {
        this._subscriptions.push(this._implementService.GetImplementMakes().subscribe(r => {
            this.makeList = r;
        }));
    }

    //Component Type For Implements
    loadComponentTypes() {
        this._subscriptions.push(this._implementService.GetComponentTypesForImplement(this.selectedImplement).subscribe(r => {
            this.componentTypeList = r;
        }));
    }
    // Gets the available implement types for the selected equipment.
    loadImplementTypes() {
        this.prevSelectedImplementType = 0;
        this._subscriptions.push(this._implementService.GetImplementTypesForEquipment(this.selectedEquipment).subscribe(r => {
            console.log("GetImplementTypesForEquipment", r)
            this.implementTypeList = r;
        }));
    }

    //save schmenatic images    
    saveSchemanticImages() {
        // Now save schematic images.
        this.SelectedschematicImageList.ImplementID = this.selectedImplement;
        this.SelectedschematicImageList.SchematicImageList = [];

        this.schematicList.filter(f => f.IsNewImage == true).forEach(s => {
            var newSchematic: SchematicUploadParams = new SchematicUploadParams();
            newSchematic.ImageName = s.ImageName;
            newSchematic.ImageData = s.Data;

            this.SelectedschematicImageList.SchematicImageList.push(newSchematic);
        });

        this.SelectedschematicImageList.ImplementID = this.selectedImplement;
        //console.log("imagelist", this.SelectedschematicImageList)
        this._implementService.SaveSchematicImageList(this.SelectedschematicImageList).subscribe(r => {
            // console.log("save schemantic", r)
            if (r) {
                this.loadImplementSchematics();
            }

        });


    }
    // Gets the list of implements that are currently loaded on the selected equipment.
    loadImplementsForEquipment() {
        this._subscriptions.push(this._implementService.GetImplementsOnEquipment(this.selectedEquipment).subscribe(r => {
            this.implementList = r;
        }));
    }

    // Gets the details of the selected implement.
    loadImplementDetails() {
        this.selectedModels = null;
        if (this.selectedImplement != 0) {
            this._subscriptions.push(this._implementService.GetImplementDetails(this.selectedImplement).subscribe(r => {
                console.log("GetImplementDetails", r)
                if (r != null) {
                    this.selectedMake = r.Make;
                    this.selectedImplementType = r.ImplementType;
                    this.serialNumber = r.SerialNo;
                    this.bcmHrs = r.Bcm;
                    this.budgetHrs = r.Hours;
                    this.tonHrs = r.Ton;
                    this.Additional_serial_num = r.additional_serial_num;
                    this.bucketCapacity = r.BucketCapacity;
                    this.selectedGETType = r.GETType;
                    this.purchaseCost = r.purchaseCost;
                    if (r.SetupDate != null) {
                        var sdParts = r.SetupDate.split('/');
                        var sdDay = parseInt(sdParts[0]);
                        var sdMonth = parseInt(sdParts[1]) - 1;
                        var sdYear = parseInt(sdParts[2]);
                        var setupDate = new Date(sdYear, sdMonth, sdDay);
                        this.dateOfReading = new Date(setupDate);
                    }
                    this.implementHours = r.ImplementHoursAtSetup;
                    this.equipmentSMU = r.EquipmentSMUAtSetup;
                   
                    this.loadSupportEquipmentModels();
                    this.loadImplementSchematics();
                }
            }));
            this.loadImplementImage();

        } else {
            this.clearImplementDetails();
        }
    }
    getImage(image: string) {
        // return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
        return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);

    }

    getPosition(posX: string, posY: string) {
        var iPX = (parseFloat(posX));// / 640.0) * this.pageConstants.THUMBNAIL_WIDTH;
        var iPY = (parseFloat(posY)); // 520.0) * this.pageConstants.THUMBNAIL_HEIGHT;
        return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
    }

    getEval(wornPct: number, inspectDate: string) {
        if ((wornPct == 0) && (inspectDate == "Never")) {
            return 'gray';
        } else if (wornPct <= 30) {
            return 'green';
        } else if ((wornPct > 30) && (wornPct <= 60)) {
            return 'yellow';
        } else if ((wornPct > 60) && (wornPct <= 80)) {
            return 'orange';
        } else if (wornPct > 80) {
            return 'red';
        }
    }

    loadImplementImage() {
        this._subscriptions.push(this._implementService.LoadImplementImage(this.selectedImplement).subscribe(r => {
            this.implementImage = r;
        }));
    }

    // Implement photo upload
    onSelectImplementPhoto(event) {
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();

            reader.readAsDataURL(event.target.files[0]); // read file as data url

            reader.onload = (event: any) => { // called once readAsDataURL is completed
                var imageUrl = (event.target["result"]);
                if (this.selectedImplement > 0)
                    this.saveImplementImage(imageUrl);
                else {
                    this.isNewImplement = true
                    this.NewImplementImage = imageUrl;
                    var sImageUrl = imageUrl.replace(/^data:image\/[a-z]+;base64,/, "");
                    sImageUrl = sImageUrl.replace(/^data:image\/\w+;base64,/, "");
                    this.implementImage = sImageUrl;
                }

                this.ImplementImageUpload.nativeElement.value = '';
            }
        }
    }

   // Schematic photo upload
//    onSelectSchematicPhoto(event) {
//     if (event.target.files && event.target.files[0]) {
//         var reader = new FileReader();

//         reader.readAsDataURL(event.target.files[0]); // read file as data url
//         this.selectedSechamnticImage = event.target.files[0]
//         reader.onload = (event: any) => { // called once readAsDataURL is completed
//             var imageUrl = (event.target["result"]);
//             //resize photo
//             this.compressImage(imageUrl).then((res: string) => {
//                 // console.log("imageUrl", res)
//                 if (res) {
//                     //console.log('res', res)

//                     //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
//                    // this.uploadPhoto(res.split(',')[1]);
//                     this.saveSchematicImage(res, this.selectedSechamnticImage);
//                 }
//             })
//             //this.saveSchematicImage(imageUrl, this.selectedSechamnticImage);

//             this.SchematicImageUpload.nativeElement.value = '';
//         }
//     }
// }



// onSelectSchematicPhoto(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     let file = event.target.files[0];
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//       const processFile = (f: File) => {
//       this.selectedSechamnticImage = f;
//       const reader = new FileReader();
//       reader.readAsDataURL(f);
//       reader.onload = (e: any) => {
//         const imageUrl = e.target.result;
//         this.compressImage(imageUrl).then((res: string) => {
//           if (res) {
//             this.saveSchematicImage(res, this.selectedSechamnticImage);
//           }
//         });
//         this.SchematicImageUpload.nativeElement.value = '';
//       };
//     };
//     if (isHeic) {
//       (heic2any as any).default({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//       })
//       .then((result: any) => {
//         const convertedBlob = Array.isArray(result) ? result[0] : result;
//         const convertedFile = new File([convertedBlob], "converted.jpg", {
//           type: "image/jpeg"
//         });
//         processFile(convertedFile);
//       })
//       .catch((err: any) => {
//         console.error("HEIC conversion failed", err);
//         this.toastr.error("Failed to process HEIC image. Please try a different image.");
//       });
//     } else {
//       processFile(file);
//     }
//   }
// }

async onSelectSchematicPhoto(event: any) {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    this.selectedSechamnticImage = f;

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = e.target.result;

      this.compressImage(imageUrl)
        .then((res: string) => {

          if (res) {
            this.saveSchematicImage(res, this.selectedSechamnticImage);
          }

        })
        .catch(err => {
          console.error(err);
        });

      this.SchematicImageUpload.nativeElement.value = '';

    };

    reader.readAsDataURL(f);
  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this.toastr.error(
      "Failed to process HEIC image. Please try a different image."
    );

    this.SchematicImageUpload.nativeElement.value = '';

  }

}
compressImage(src: any) {
    return new Promise((res, rej) => {
        const img = new Image();




        img.src = src;
        img.onload = () => {
            const elem = document.createElement('canvas');

            let width, height;
            width = img.width;
            height = img.height;

            console.log('width', width)
            console.log('height', height)

            var ratio = height / width; //cal aspect ratio
            let imageWidth = 800;//643
            var new_height = imageWidth * ratio; //calculate new height


            elem.width = imageWidth;
            elem.height = new_height;
            const ctx = elem.getContext('2d');
            ctx.drawImage(img, 0, 0, imageWidth, new_height);
            const data = ctx.canvas.toDataURL();
            res(data);
        }
        img.onerror = error => rej(error);
    })
}


    // Save the implement image.
    saveImplementImage(imageUrl: string) {
        var saveParams: SaveImplementImageParams = new SaveImplementImageParams();
        saveParams.GETAuto = this.selectedImplement;
        saveParams.ImageData = imageUrl;
        this._subscriptions.push(this._implementService.SaveImplementImage(saveParams).subscribe(r => {
            if (r) {
                this.loadImplementImage();
            }
        }));
    }

    //remove implement image
    deleteImplementImage() {
        var saveParams: SaveImplementImageParams = new SaveImplementImageParams();
        saveParams.GETAuto = this.selectedImplement;
        this._subscriptions.push(this._implementService.DeleteImplementImage(saveParams).subscribe(r => {
            if (r) {
                this.toastr.success("Deleted successfully");
                this.implementImage = null;
                this.NewImplementImage = null;
            }
        }));

    }
    // Save the schematic image temporarily.
    saveSchematicImage(imageUrl: string, imageName: File) {
        var sImageUrl = imageUrl.replace(/^data:image\/[a-z]+;base64,/, "");
        sImageUrl = sImageUrl.replace(/^data:image\/\w+;base64,/, "");
        this.schematicList.push({
            Id: this.NewSchematicId,
            Data: sImageUrl,
            ImageName: imageName.name,
            ObservationPoints: [],
            IsNewImage: true,
             SortOrder:this.schematicList.length,
             OBSCount: 0,
             InactiveOBSCount: 0,
             ComponentTypeIds: '',
             IsHidden: false

        });
        this.NewSchematicId++;
    }


    // Load the schematics, components (aka measurement points) and
    // observation points on Tab 3.
    loadComponentsAndObservationPoints() {
        //this.loadComponentsForImplement();
        this.loadObservationPointsForImplement();
        this.loadImplementSchematics();
    }

    // Load the observation lists for the selected customer.
    loadObservationLists() {
        this._subscriptions.push(this._implementService.GetObservationLists(this.selectedCustomer, this.selectedImplement).subscribe(r => {
            this.observationLists = r;

        }));
    }

    // Load the Observation Point types.
    loadObservationPointTypes() {
        this._subscriptions.push(this._implementService.GetObservationPointTypes().subscribe(r => {
            this.observationPointTypes = r;

            //this.observationPointTypes =  r.filter(x=>x.Id != 3)
        }));
    }

    // Load the Observation Points for the selected GET and implement type.
    loadObservationPointsForImplement() {
        this._subscriptions.push(this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
            this.observationPoints = r;
            this.observationListFiltered = r;
            // this.observationListFiltered.map(x=>{
            //     if(x.ObservationPointType == 3){
            //         x.NumberOfReadings =null;
            //         x.LimitNew=null;
            //         x.LimitScrap=null;
            //     }
            // })
            this.observationListAfterChanages = r;
        }));
    }

    // Load the Implement Schematics.
    loadImplementSchematics() {
        // Fix issue where selectedImplement resets to 0 on navigating away.
        var implementId = this.selectedImplement;
        if ((implementId == 0) && (!isNaN(this.attachedImplementSelected))) {
            implementId = this.attachedImplementSelected;
        }
        console.log("implementId", implementId)
        this._subscriptions.push(this._implementService.GetSchematicData(implementId).subscribe(r => {
            this.schematicList = r;
        }));
    }

    onSelectEquipment() {
        if (this.selectedEquipment != null) {
            this._equipmentId = this.selectedEquipment;
            this.loadImplementTypes();
            this.loadEquipmentDetails(0)

            if (this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_EXISTING) {
                this.loadImplementsForEquipment();
            }
        }


    }

    loadmodelfromEquipment() {

        this.target = [];
        if (this.equipmentmodel != null) {
            let val = new GenericIdName();
            val.Name = this.equipmentmodel.Name;
            val.Id = this.equipmentmodel.Id;
            this.loradtarget.push(val)
        }
        this.equipmentmodel = null;
        console.log("loadtarget", this.loradtarget);
        this.target = this.loradtarget;
    }
    onImplementSelected() {
        this.attachedImplementSelected = this.selectedImplement;
        this.loadAvailableModelList();
        this.loadImplementDetails();
        this.isNewImplement = false
    }

    checkOkToCopy(): ValidationErrorStatus {
        var result: ValidationErrorStatus = {
            Status: false,
            Message: ""
        };

        let valid_customer = this.selectedCustomer > 0 ? true : false;
        let valid_jobsite = this.selectedJobsite > 0 ? true : false;
        let valid_equipment = this.selectedEquipment > 0 ? true : false;

        if (this.equipmentOrInventory == this.pageConstants.SETUP_ON_EQUIPMENT) {
            if (valid_customer && valid_jobsite && valid_equipment) {
                result.Status = true;
            } else {
                result.Status = false;
                result.Message = "Please enter customer, jobsite and equipment.";
            }
        } else if (this.equipmentOrInventory == this.pageConstants.SETUP_IN_INVENTORY) {
            if (valid_customer && valid_jobsite) {
                result.Status = true;
            } else {
                result.Status = false;
                result.Message = "Please enter customer and jobsite.";
            }
        } else {
            result.Status = false;
            result.Message = "Please select either Equipment or Jobsite Inventory.";
        }

        return result;
    }

    copyImplementFromExisting() {
        var OkToCopy = this.checkOkToCopy();
        if (!OkToCopy.Status) {
            this.toastr.error(OkToCopy.Message);
        } else {
            let copyImplementModalRef = this.dialog.open(CopyImplementDialogComponent, {
                width: '1024px',
                height: '780px',
                data: {
                    equipmentId: this.selectedEquipment,
                    jobsiteId: this.selectedJobsite,
                    //isClose:false
                }
            });
            copyImplementModalRef.afterClosed().subscribe(r => {
                if (r.data != null) {
                    // if(r.data.isClose==true)
                    // {
                    //     this._subscriptions.push(this._implementService.GetTemplateListForUser().subscribe(r => {
                    //         this.implementTypeList = r;
                    //     }));
                    // }
                } else {

                }
            });
        }
    }

    resetSelectType(e) {
        this.selectedImplementType = 0
    }
    TypeSelect: boolean = false
    onImplementTypeSelected() {
        this.loadAvailableModelList();

        // Cannot change for existing implements
        if (this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_EXISTING) {
            this.toastr.error(this.pageErrors.ERROR_CHANGING_IMPLEMENT_TYPE);
            this.clearImplementDetails();
        }
        // Allow the implement type to be changed if this implement was just created.
        else if (this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_NEW) {
            // if (this.prevSelectedImplementType != 0 && this.selectedImplementType != 0 && this.prevSelectedImplementType != this.selectedImplementType) {
            //     this.showDeleteConfirmationDialog();
            // } else if (this.selectedImplementType == 0 && this.prevSelectedImplementType != 0) {
            //     this.toastr.error(this.pageErrors.ERROR_INVALID_IMPLEMENT_TYPE);
            //     this.selectedImplementType = this.selectedImplementType;
            // } else {
            //     this.prevSelectedImplementType = this.selectedImplementType;
            // }


            //new code for select implement type and new implementtype
            if (this.selectedImplementType > 0) {
                this.NewimplementType = "";
            }
            else if (this.NewimplementType != undefined || this.NewimplementType.trim().length != 0) {
                this.TypeSelect = false;
                this.selectedImplementType = 0;

            }

        }


    }

    showDeleteConfirmationDialog() {
        let confirmationModalRef = this.dialog.open(GETDeleteConfirmationDialogComponent, {
            width: '480px',
            height: '280px'
        });
        confirmationModalRef.afterClosed().subscribe(r => {
            if ((r.data != null) && (r.data.goAhead)) {

                // Confirm delete
                this.prevSelectedImplementType = this.selectedImplementType;
                this._implementService.DeleteImplement(this.attachedImplementSelected).subscribe(r2 => {
                    if (r2) {
                        this.toastr.info(this.pageConstants.INFO_IMPLEMENT_DELETED);
                        this.attachedImplementSelected = 0;
                        this.selectedImplement = 0;
                    } else {
                        this.toastr.error(this.pageErrors.ERROR_SAVING_CHANGES);
                    }
                });
            } else {
                // Don't delete
                this.selectedImplementType = this.prevSelectedImplementType;
            }
        });
    }

    onNumReadingsEntered(OP, e) {

        if (e.target.value < 0) {
            OP.NumReadings = 0;
            this.toastr.error("Please enter a value between 0 - 5 for the readings");
            // this.isvalidStep3 = false
        } else if (e.target.value > 5) {
            OP.NumReadings = 5;
            this.toastr.error("Please enter a value between 0 - 5 for the readings")
            //this.isvalidStep3 = false

        } else {
            OP.NumReadings = parseInt(e.target.value.toString().replace('+', '').replace('-', ''))

        }

        //OP.NumReadings = parseInt(e.target.value.toString().replace('+', '').replace('-', ''))
    }

    onLimitsEntered(OP, e) {
        if (e.target.value > 0) {
            if (OP.NumReadings == 0) {
                this.toastr.error("Can not enter Limits, unless you have specified No of reading");
                e.target.value = 0;
            }
        }

    }
    onNewOPLimitNewEntered(e) {
        this.newOPLimitNew = e.target.value;
    }

    onNewOPLimitScrapEntered(e) {
        this.newOPLimitScrap = e.target.value;
    }

    onPartNumberChanged(MP, e) {
        MP.PartNo = e.target.value;
    }

    // Handle the right-click 'select and copy' context menu.
    // e: the right-click context menu event.
    // isMP: if true then it is for measurement point, otherwise an observation point.
    // id: the Id of the measurement point or observation point in the row selected.
    // category: whether this is the make, observation list, initial length or worn length.
    // val: the value to be copied across.
    displayContextMenu(e, isMP, id, category) {
        this.showContextMenu = true;
        this.contextMenuY = e.pageY + 'px';
        this.contextMenuX = e.pageX + 'px';


        this.selectionData.Id = id;
        this.selectionData.Category = category;
        if (category == "ObservationList") {
            this.selectionData.Val = isMP
            this.selectionData.IsMP = false;
        }
        else {
            this.selectionData.Val = e.target.value;
            this.selectionData.IsMP = isMP;
        }

        this.clearHighlights();
    }

    // Hide the context menu.
    hideContextMenu(e) {
        this.showContextMenu = false;
    }

    // Clear the highlight for previously updated cells.
    clearHighlights() {
        this.showAllCells = false;
        this.showVacantCells = false;
    }

    // Copy the selection data to all cells for the category. (canOverwrite=true)
    copySelectionToAll(e) {
        this.copySelection(e, true);
    }

    // Copy the selection data only to the vacant cells for the category. (canOverwrite=false)
    copySelectionToVacant(e) {
        this.copySelection(e, false);
    }

    // Handles the main logic for copying selected data to all cells for the category.
    copySelection(e, canOverwrite) {
        if (this.selectionData != null) {
            // Handle Measurement Points
            if (this.selectionData.IsMP) {

                for (var i = 0; i < this.componentList.length; i++) {
                    this.updateDataBasedOnCategory(this.componentList, i, canOverwrite);
                }
            }

            // Handle Observation Points
            else {
                for (var i = 0; i < this.observationPoints.length; i++) {
                    this.updateDataBasedOnCategory(this.observationPoints, i, canOverwrite);
                }
            }
        }
    }

    // Handles the assignment logic for each category.
    updateDataBasedOnCategory(src, index, canOverwrite) {

        if (this.selectionIsMake()) {
            if ((src[index].Make == 0) || (canOverwrite)) {
                src[index].Make = this.selectionData.Val;
            }
        } else if (this.selectionIsObservationList()) {
            if ((src[index].ObservationListIds == 0) || (canOverwrite)) {
                src[index].ObservationListIds = this.selectionData.Val;
            }
        } else if (this.selectionIsLimitNew()) {
            if (this.checkIfVacant(this.pageConstants.COL_INITIAL_LENGTH, src[index].LimitNew, src[index].LimitScrap) || (canOverwrite)) {
                src[index].LimitNew = this.selectionData.Val;
            }
        } else if (this.selectionIsLimitScrap()) {
            if (this.checkIfVacant(this.pageConstants.COL_WORN_LENGTH, src[index].LimitNew, src[index].LimitScrap) || (canOverwrite)) {
                src[index].LimitScrap = this.selectionData.Val;
            }
        } else if (this.selectionIsPartNo()) {
            if (this.checkIfVacant(this.pageConstants.COL_PART_NO, src[index].PartNo, null) || (canOverwrite)) {
                src[index].PartNo = this.selectionData.Val;
            }
        } else if (this.selectionIsNumberOfReadings()) {
            if (this.checkIfVacant(this.pageConstants.COL_NUM_READINGS, src[index].NumberOfReadings, null) || (canOverwrite)) {
                src[index].NumberOfReadings = this.selectionData.Val;
            }
        } else if (this.selectionIsObservationPointType()) {
            if ((src[index].ObservationPointType == 0) || (canOverwrite)) {
                src[index].ObservationPointType = this.selectionData.Val;
            }
        } else if (this.selectionIsObservationPointName()) {
            if (this.checkIfVacant(this.pageConstants.COL_OP_NAME, src[index].Name, null) || (canOverwrite)) {
                src[index].Name = this.selectionData.Val;
            }
        }else if (this.selectionIsObservationPointQName()) {
            if (this.checkIfVacant(this.pageConstants.COL_OP_Q_NAME, src[index].QName, null) || (canOverwrite)) {
                src[index].QName = this.selectionData.Val;
            }
        }else if (this.selectionIsObservationPointQDesc()) {
            if (this.checkIfVacant(this.pageConstants.COL_OP_Q_DESC, src[index].QDesc, null) || (canOverwrite)) {
                src[index].QDesc = this.selectionData.Val;
            }
        }
    }

    // Returns true if the selected cell is for 'Make'.
    selectionIsMake() {
        if (this.selectionData.Category == this.pageConstants.COL_MAKE) {
            return true;
        }
        return false;
    }

    // Returns true if the selected cell is for 'Observation List'.
    selectionIsObservationList() {
        if (this.selectionData.Category == this.pageConstants.COL_OBSERVATION_LIST) {
            return true;
        }
        return false;
    }

    // Returns true if the selected cell is for 'Initial Length'.
    selectionIsLimitNew() {
        if (this.selectionData.Category == this.pageConstants.COL_INITIAL_LENGTH) {
            return true;
        }
        return false;
    }

    // Returns true if the selected cell is for 'Worn Length'.
    selectionIsLimitScrap() {
        if (this.selectionData.Category == this.pageConstants.COL_WORN_LENGTH) {
            return true;
        }
        return false;
    }

    // Returns true if the selected cell is for 'Part No'.
    selectionIsPartNo() {
        if (this.selectionData.Category == this.pageConstants.COL_PART_NO) {
            return true;
        }
        return false;
    }

    // Returns true if the selected cell is for 'Number Of Readings'.
    selectionIsNumberOfReadings() {
        if (this.selectionData.Category == this.pageConstants.COL_NUM_READINGS) {
            return true;
        }
        return false;
    }

    // Returns true if the selected cell is for 'Observation Point Type'.
    selectionIsObservationPointType() {
        if (this.selectionData.Category == this.pageConstants.COL_OP_TYPE) {
            return true;
        }
        return false;
    }

    // Returns true if the selected cell is for 'Observation Point Name'.
    selectionIsObservationPointName() {
        if (this.selectionData.Category == this.pageConstants.COL_OP_NAME) {
            return true;
        }
        return false;
    }

       // Returns true if the selected cell is for 'Observation Point Name'.
       selectionIsObservationPointQName() {
        if (this.selectionData.Category == this.pageConstants.COL_OP_Q_NAME) {
            return true;
        }
        return false;
    }

      // Returns true if the selected cell is for 'Observation Point Name'.
      selectionIsObservationPointQDesc() {
        if (this.selectionData.Category == this.pageConstants.COL_OP_Q_DESC) {
            return true;
        }
        return false;
    }

    selectionIsObservationPointLimitRange() {
        if (this.selectionData.Category == this.pageConstants.COL_OP_LIMITRANGE) {
            return true;
        }
        return false;
    }

    selectionIsObservationPointMeasurement() {
        if (this.selectionData.Category == this.pageConstants.COL_OP_MEASUREMENT) {
            return true;
        }
        return false;
    }
    // Check if the cell is vacant.
    // The Make and Observation List cells are vacant if the first entry is selected.
    // Initial and Worn lengths are considered blank if both those cells are 0,
    // or if one of those cells is empty.
    // Part number and Number of Readings are vacant if the cell contains no valid characters or is null.
    checkIfVacant(cat, val1, val2) {
        if (cat == this.pageConstants.COL_MAKE || cat == this.pageConstants.COL_OBSERVATION_LIST || cat == this.pageConstants.COL_OP_TYPE) {
            if (val1 == 0) {
                return true;
            }
        }

        else if (cat == this.pageConstants.COL_INITIAL_LENGTH || cat == this.pageConstants.COL_WORN_LENGTH) {
            if (cat == this.pageConstants.COL_INITIAL_LENGTH && (val1 == "" || val1 == null)) {
                return true;
            }
            else if (cat == this.pageConstants.COL_WORN_LENGTH && (val2 == "" || val2 == null)) {
                return true;
            }
            else if (val1 == 0 && val2 == 0) {
                return true;
            }
        }

        else if ((cat == this.pageConstants.COL_PART_NO) || (cat == this.pageConstants.COL_NUM_READINGS) || (cat == this.pageConstants.COL_OP_NAME) ||(cat == this.pageConstants.COL_OP_Q_NAME) ||(cat == this.pageConstants.COL_OP_Q_DESC)) {
            if (val1 == "" || val1 == null) {
                return true;
            }
        }

        return false;
    }

    // Enable or Disable highlighting for selected vacant cells.
    toggleVacantCells(status) {
        this.showVacantCells = status;
    }

    // Enable or Disable highlighting for all selected cells.
    toggleAllCells(status) {
        this.showAllCells = status;
    }

    //////////////////////////////////////////////
    // Helper functions for CSS Highlight logic //
    //////////////////////////////////////////////

    highlightCopyImplementIcon() {
        this.mouseoverITReplicate = !this.mouseoverITReplicate;
    }

    highlightMake(val) {
        if ((this.showAllCells) || (this.showVacantCells && val == 0)) {
            if (this.selectionIsMake() && this.selectionData.IsMP) {
                return true;
            }
        }
        return false;
    }

    highlightObservationList(val) {
        if ((this.showAllCells) || (this.showVacantCells && val == 0)) {
            if (this.selectionIsObservationList()) {
                return 2;
            }
        }
        return 0;
    }

    highlightLimitNew(il, wl) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_INITIAL_LENGTH, il, wl))) {
            if (this.selectionIsLimitNew()) {
                if (this.selectionData.IsMP) {
                    return 1;
                } else {
                    return 2;
                }
            }
        }
        return 0;
    }

    highlightLimitScrap(il, wl) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_WORN_LENGTH, il, wl))) {
            if (this.selectionIsLimitScrap()) {
                if (this.selectionData.IsMP) {
                    return 1;
                } else {
                    return 2;
                }
            }
        }
        return 0;
    }

    highlightPartNo(val) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_PART_NO, val, null))) {
            if (this.selectionIsPartNo() && this.selectionData.IsMP) {
                return true;
            }
        }
        return false;
    }

    highlightNumberOfReadings(val) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_NUM_READINGS, val, null))) {
            if (this.selectionIsNumberOfReadings()) {
                return true;
            }
        }
        return false;
    }

    highlightName(val) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_NAME, val, null))) {
            if (this.selectionIsObservationPointName()) {
                return true;
            }
        }
        return false;
    }

    highlightQName(val) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_Q_NAME, val, null))) {
            if (this.selectionIsObservationPointQName()) {
                return true;
            }
        }
        return false;
    }
    highlightQDesc(val) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_Q_DESC, val, null))) {
            if (this.selectionIsObservationPointQDesc()) {
                return true;
            }
        }
        return false;
    }

    highlightLimitRange(val) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_LIMITRANGE, val, null))) {
            if (this.selectionIsObservationPointLimitRange()) {
                return true;
            }
        }
        return false;
    }

    highlightMeasurement(val) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_MEASUREMENT, val, null))) {
            if (this.selectionIsObservationPointMeasurement()) {
                return true;
            }
        }
        return false;
    }
    
    highlightType(val) {
        if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_TYPE, val, null))) {
            if (this.selectionIsObservationPointType()) {
                return true;
            }
        }
        return false;
    }

    /////////////////////////////
    // Handle Schematic Window //
    /////////////////////////////

    openEnlargedImage(iImage, imgOrSchematic) {
        var img1: SchematicDataVM = new SchematicDataVM();
        img1.Id = 0;
        img1.ObservationPoints = null;
        img1.Data = iImage;

        this.openSchematicWindow(img1, imgOrSchematic);
    }
    isTemplate:boolean=false;
    openSchematicWindow(schematic, imgOrSchematic) {
        this.isTemplate = this.equipmentOrInventory=='3'?true:false;
        
        if (this.currentStep == 0) {
            this.schematicPositionX = 1100;
            this.schematicPositionY = 500;
        }
        else {
            this.schematicPositionX = 500;
            this.schematicPositionY = 250;
        }

        this.prevMouseX = 0;
        this.prevMouseY = 0;
        this.selectedSchematic = schematic;
        this.showSchematic = true;
        if (imgOrSchematic == 1) {
            this.draggableSchematicTitle = "Implement Image";
        } else if (imgOrSchematic == 2) {
            this.draggableSchematicTitle = "Schematic";
        }
   console.log(this.selectedSchematic);
    }

    //edit observation point dialog
    openSchematicWindowforEdit( obserationID, imgOrSchematic) {
        
        if (imgOrSchematic == 1) {
            this.draggableSchematicTitle = "Implement Image";
        } else if (imgOrSchematic == 2) {
            this.draggableSchematicTitle = "Schematic";
        }
        this._implementService.GetSchematicDataForEditObsevationPoint(obserationID).subscribe(r => {
            console.log('r', r)
          
          
            if(r.length>0)
            {
                this.selectedSchematicEdit=r[0]
                const addSectionDialog = this.dialog.open(SchemanticOpPopupEditComponent, {
         
                    data: {
                      schematic: this.selectedSchematicEdit,
                      currentStep:this.currentStep,
                      mouseoverOPId:this.mouseoverOPId,
                      title:this.draggableSchematicTitle
                     
                    }
                  });
                  addSectionDialog.afterClosed().subscribe(details => {         
               
                  });
          
            }
           
        });

        
    }





    //GET-424
    //delete observation point
    deleteOP(op) {
        console.log("op_", op)
        if (op.NumberOfReadings >= 1) {
            //check any readings exists
            this.check_op_has_any_readings(op.Id)
            //if not delete op

            //if exists disable button and alert
        } else {

        }


    }

    check_op_has_any_readings(op_id) {

        this._implementService.DeleteObservationPoint(op_id).subscribe((r: any) => {
            console.log('r', r)
            let json_ = JSON.parse(r)
            if (json_['status'] == true) {
                this.toastr.success(json_['message']);
                this.loadObservationPointsForImplement();
                //window.location.reload(false); 
            } else {

                console.log('r___', json_['message'], json_['status'])
                this.toastr.error(json_['message']);
            }
        })


        // this._subscriptions.push(this._implementService.DeleteObservationPoint(op_id).subscribe(r => {
        //     console.log('r', r)

        //     if(r.status == true){
        //         this.toastr.success(r.message);
        //         this.loadOLDObservationPointsForImplement();
        //         //window.location.reload(false); 
        //     }else{

        //         console.log('r___', r.message,r)
        //         this.toastr.error(r.message);
        //     }
        // }));
    }

    onCloseSchematicWindow(e) {
        this.showSchematic = false;
        this.loadObservationPointsForImplement();
        // this.loadImplementSchematics();
        this.loadObservationLists();
    }

    onSaveObservation(e) {
        this.loadObservationPointsForImplement();
        // this.loadImplementSchematics();
        this.loadObservationLists();
    }


    onMouseButton_Schematic(e) {
        this.isMouseDown = e.buttons === 1;
        e.preventDefault();

        this.prevMouseX = e.pageX;
        this.prevMouseY = e.pageY;
    }

    onMouseMove_Schematic(e) {
        if (this.isMouseDown) {

            if ((this.prevMouseX > 0) && (this.prevMouseY > 0)) {
                this.schematicPositionX += (e.pageX - this.prevMouseX);
                this.schematicPositionY += (e.pageY - this.prevMouseY);

                this.prevMouseX = e.pageX;
                this.prevMouseY = e.pageY;
            }

            else {
                this.prevMouseX = e.pageX;
                this.prevMouseY = e.pageY;
            }
        }
        e.preventDefault();
    }


    //////////////////////////////////////
    // Mouse hover logic for table rows //
    //////////////////////////////////////

    onMouseOverMP(id) {
        this.mouseoverMPId = id;
    }

    onMouseOutMP() {
        this.mouseoverMPId = 0;
    }

    onMouseOverOP(id) {
        this.mouseoverOPId = id;
    }

    onMouseOutOP() {
        this.mouseoverOPId = 0;
    }

    /////////////////////////
    // Tab 1 Radio buttons //
    /////////////////////////

    // Set up a new implement.
    setupNewImplement() {
        this.clearAll();
    }

    // Modify an existing implement.
    modifyImplement() {
        this.clearAll();
    }

    // Implement is on an equipment.
    loadOntoEquipment() {
        this.clearAll();
        this.IsTemplate=false;
    }

    // Implement is in inventory.
    createInInventory() {
        this.IsTemplate=false;

        // Only proceed if the jobsite is selected.
        if (this.selectedJobsite == null) {
            return;
        }

        this.clearAll();
        
        this._subscriptions.push(this._implementService.GetTemplateListForUserFilterByCustomer(this.selectedCustomer).subscribe(r => {
            console.log("GetTemplateListForUserFilterByCustomer", r)

            this.implementTypeList = r;
        }));

        if (this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_NEW) {
            // New
        } else {
            // Existing
            this._subscriptions.push(this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
                this.implementList = r;
            }));
        }
    }
    

    // Implement is in Template.
    createInTemplate() {
        // Only proceed if the jobsite is selected.
        if (this.selectedJobsite == null) {
            return;
        }

        this.clearAll();
        
        this._subscriptions.push(this._implementService.GetTemplateListForUserFilterByCustomer(this.selectedCustomer).subscribe(r => {
            console.log("GetTemplateListForUserFilterByCustomer", r)

            this.implementTypeList = r;
        }));

        if (this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_NEW) {
            // New
        } else {
            // Existing
            this._subscriptions.push(this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
                this.implementList = r;
            }));
        }
        this.IsTemplate=true;
    }
    clearAll() {
        this.attachedImplementSelected = 0;
        this.selectedImplement = 0;
        this.selectedEquipment = 0;
        this.clearImplementDetails();
    }

    // Clear the Implement details.
    clearImplementDetails() {
        this.serialNumber = "";
        this.selectedImplementType = 0;
        this.prevSelectedImplementType = 0;
        this.selectedMake = 0;
        this.dateOfReading = new Date();
        this.implementHours = 0;
        this.equipmentSMU = 0;
        this.implementImage = '';
        this.schematicList = [];
    }

    ////////////////////
    // Tab 2 - update //
    ////////////////////

    validateImplementSerial() {
        this._implementService.ValidateImplementSerial(this.selectedImplement, this.serialNumber).subscribe(r => {
            if (!r) {
                this.toastr.error(this.pageErrors.ERROR_SERIALNO_VALIDATION_FAILED);
                this.serialNumber = "";
            }
        });
    }

    createImplementDetailParams(): SaveImplementDetailParams {
        var details: ImplementDetails = new ImplementDetails();
        details.Id = this.selectedImplement;
        details.ImplementType = this.selectedImplementType;
        details.Make = this.selectedMake;
        details.SerialNo = this.serialNumber;
        details.SetupDate = this.dateOfReading.getDate() + "/"
            + (this.dateOfReading.getMonth() + 1) + "/" + this.dateOfReading.getFullYear();
        details.ImplementHoursAtSetup = this.implementHours;
        details.EquipmentSMUAtSetup = this.equipmentSMU;
        details.Hours = this.budgetHrs;
        details.Bcm = this.bcmHrs;
        details.Ton = this.tonHrs;
        details.additional_serial_num = this.Additional_serial_num
        details.purchaseCost = this.purchaseCost;
        details.IsTemplate=this.equipmentOrInventory=='3'?true:false;
        details.GETType=this.selectedGETType;
        details.BucketCapacity=this.bucketCapacity;
        var params = new SaveImplementDetailParams();
        params.Details = details;
        params.EquipmentId = this.selectedEquipment;
        params.JobsiteId = this.selectedJobsite;
        
        

        return params;
    }

    ////////////////
    // Navigation //
    ////////////////

    step1Validation(): ValidationErrorStatus {
        var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
        validationResult.Status = true;
        validationResult.Message = "";

        if ((this.selectedCustomer == null) || (this.selectedCustomer <= 0)) {
            validationResult.Status = false;
            validationResult.Message = "Please select 'Customer'";
        }

        else if ((this.selectedJobsite == null) || (this.selectedJobsite <= 0)) {
            validationResult.Status = false;
            validationResult.Message = "Please select 'Jobsite'";
        }

        else if ((this.equipmentOrInventory == this.pageConstants.SETUP_ON_EQUIPMENT)
            && ((this.selectedEquipment == null) || (this.selectedEquipment <= 0))) {
            validationResult.Status = false;
            validationResult.Message = "Please select 'Equipment'";
        }

        else if ((this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_NEW)
            && (this.serialNumber.trim() == "")) {
            validationResult.Status = false;
            validationResult.Message = "Please select 'Implement'";
        }

        else if ((this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_EXISTING)
            && ((this.selectedImplement == null) || (this.selectedImplement <= 0))) {
            validationResult.Status = false;
            validationResult.Message = "Please select 'Implement'";
        }

        else if ((this.selectedMake == null) || (this.selectedMake <= 0)) {
            validationResult.Status = false;
            validationResult.Message = "Please select an Implement Make";
        }

        else if ((this.selectedModels == null) && this.equipmentOrInventory=='3') {
            validationResult.Status = false;
            validationResult.Message = "Please select Model";
        }

        else if (this.implementHours == null || this.implementHours < 0) {
            validationResult.Status = false;
            validationResult.Message = "Implement Hours is invalid!";
        }

        else if (this.equipmentSMU == null || this.equipmentSMU < 0) {
            validationResult.Status = false;
            validationResult.Message = "Equipment SMU is invalid!";
        }

        else if ((this.selectedImplementType == 0) && (this.NewimplementType == undefined || this.NewimplementType.trim().length == 0)) {
            validationResult.Status = false;
            validationResult.Message = "Please Enter/Select Implement Type";
        }

        else if ((this.selectedImplementType > 0) && !(this.NewimplementType == undefined || this.NewimplementType.trim().length == 0)) {
            validationResult.Status = false;
            validationResult.Message = "Can not select both 'Select Implement Type' and 'Create new Implement Type'";
        }

        if (this.ismodified == false) {
            if (this.purchaseCost == null) {
                this.purchaseCost = 0;
            }
            if (this.purchaseCost < 0) {
                validationResult.Status = false;
                validationResult.Message = "Purchased Cost is invalid!";
            }
        }

        // else if ((this.selectedModels === undefined) || (this.selectedModels.length == 0)) {
        //     validationResult.Status = false;
        //     validationResult.Message = "Please select compatible models.";
        // }

        return validationResult;
    }

    validateAndProcessTab1(): Promise<ValidationErrorStatus> {
        return new Promise<ValidationErrorStatus>(resolve => {

            var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
            validationResult.Status = true;
            validationResult.Message = "";

            if ((this.selectedImplementType > 0) && (this.NewimplementType == undefined || this.NewimplementType.trim().length == 0)) {
                this.SaveorUpdateImplement().then(v => {
                    console.log("saveorupdateImplement,", v)
                    validationResult = v;
                    resolve(validationResult);
                }).catch(err => {
                    console.log(err);
                    resolve(validationResult);
                });
            }

            else if ((this.selectedImplementType == 0) && !(this.NewimplementType == undefined || this.NewimplementType.trim().length == 0)) {

                var params1: saveNewImplementTypeVM = new saveNewImplementTypeVM();
                params1.customerId = this.selectedCustomer;
                params1.NewimplementType = this.NewimplementType;

                this._implementService.SaveImplementType(params1).subscribe(response => {
                    if (response > 0) {
                        this.selectedImplementType = response;
                        this.NewimplementType = "";

                        this.SaveorUpdateImplement().then(v => {
                            if (!v.Status) {
                                this._implementService.RemoveNewImplementType(this.selectedImplementType).subscribe(r2 => {
                                    if (r2) {
                                        this.selectedImplementType = 0;
                                        this.loadImplementTypes();
                                    }
                                });
                            }

                            validationResult = v;
                            resolve(validationResult);
                        }).catch(err => {
                            console.log(err);
                            resolve(validationResult);
                        });
                    }
                    else {
                        validationResult.Status = false;
                        validationResult.Message = "Implement Type already exists for this customer";
                        resolve(validationResult);
                    }
                });
            }

        });
    }

    validateSmuAndLtd(): Promise<ValidationErrorStatus> {
        return new Promise<ValidationErrorStatus>(resolve => {

            var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
            validationResult.Status = true;
            validationResult.Message = "";

            var setupDateParts = this.dateOfReading.getDate() + "/" + (this.dateOfReading.getMonth() + 1) + "/" + this.dateOfReading.getFullYear();
            var vSetupDate = this._implementService.ValidateImplementSetupDate(this.attachedImplementSelected, setupDateParts);
            var vSetupLTD = this._implementService.ValidateImplementSetupLTD(this.attachedImplementSelected, this.implementHours);

            // Equipment
            if (this.equipmentOrInventory == this.pageConstants.SETUP_ON_EQUIPMENT) {
                if ((this.selectedEquipment != null) && (setupDateParts != "")) {
                    var vEquipmentSMU = this._implementService.ValidateEquipmentSMUAtSetup(this.attachedImplementSelected, this.selectedEquipment, this.equipmentSMU, setupDateParts);
                    console.log("vEquipmentSMU", vEquipmentSMU);
                    var forkJoin1 = Observable.forkJoin(vSetupLTD, vSetupDate, vEquipmentSMU).subscribe(
                        data => {
                            //console.log("DATA", data[0], data[1], data[2])
                            if (data[0] && data[1] && data[2]) {
                                this.validateAndProcessTab1().then(v => {
                                    validationResult = v;
                                    resolve(validationResult);

                                }).catch(err => {
                                    console.log(err);
                                    resolve(validationResult);
                                });
                            } else {
                                validationResult.Status = false;

                                if (!data[0]) {
                                    validationResult.Message += "\n" + this.pageErrors.ERROR_VALIDATION_IMPLEMENT_LIFE;
                                }
                                if (!data[1]) {
                                    validationResult.Message += "\n" + this.pageErrors.ERROR_VALIDATION_SETUP_DATE;
                                }
                                if (!data[2]) {
                                    validationResult.Message += "\n" + this.pageErrors.ERROR_VALIDATION_EQUIPMENT_SMU;
                                }

                                resolve(validationResult);
                            }
                        }
                    );
                }
                //console.log("if end equipment", validationResult)
            }
            // Inventory
            else {
                var forkJoin2 = Observable.forkJoin(vSetupLTD, vSetupDate).subscribe(
                    data => {
                        if (data[0] && data[1]) {
                            this.validateAndProcessTab1().then(v => {
                                validationResult = v;
                                resolve(validationResult);
                            }).catch(err => {
                                console.log(err);
                                resolve(validationResult);
                            });
                        } else {
                            validationResult.Status = false;

                            if (!data[0]) {
                                validationResult.Message += "\n" + this.pageErrors.ERROR_VALIDATION_IMPLEMENT_LIFE;
                            }
                            if (!data[1]) {
                                validationResult.Message += "\n" + this.pageErrors.ERROR_VALIDATION_SETUP_DATE;
                            }

                            resolve(validationResult);
                        }
                    }
                );
            }

            console.log("end validationResult", validationResult)
        });


    }

    SaveorUpdateImplement(): Promise<ValidationErrorStatus> {
        return new Promise<ValidationErrorStatus>(resolve => {

            var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
            validationResult.Status = true;
            validationResult.Message = "";

            var params = this.createImplementDetailParams();

            this._implementService.UpdateImplement(params).subscribe(r => {
                console.log("params___update___", params)
                if (r != null) {
                    if (r < 0) {
                        validationResult.Status = false;
                        validationResult.Message = this.pageErrors.ERROR_SAVING_CHANGES;
                        resolve(validationResult);
                    }

                    else {
                        this.selectedImplement = r;
                        this.attachedImplementSelected = r;
                        this.loadComponentTypes();
                        var params: SaveModeltParams = new SaveModeltParams();
                        params.ImplementId = this.selectedImplementType;
                        params.ModelList = this.selectedModels;

                        // this._implementService.SaveImplementModelDetails(params).subscribe(result => {
                        //     if (result == false) {
                        //         validationResult.Status = false;
                        //         validationResult.Message = this.pageErrors.ERROR_SAVING_CHANGES;
                        //         resolve(validationResult);
                        //     } else {
                        //         // Now save schematic images.
                        //         this.SelectedschematicImageList.ImplementID = r;
                        //         this.SelectedschematicImageList.SchematicImageList = [];

                        //         this.schematicList.filter(f => f.IsNewImage == true).forEach(s => {
                        //             var newSchematic: SchematicUploadParams = new SchematicUploadParams();
                        //             newSchematic.ImageName = s.ImageName;
                        //             newSchematic.ImageData = s.Data;

                        //             this.SelectedschematicImageList.SchematicImageList.push(newSchematic);
                        //         });

                        //         this.SelectedschematicImageList.ImplementID = r;
                        //         this._implementService.SaveSchematicImageList(this.SelectedschematicImageList).subscribe(r => {
                        //         });

                        //         resolve(validationResult);
                        //     }
                        // });
                        if (this.NewImplementImage != "") {
                            var saveParams: SaveImplementImageParams = new SaveImplementImageParams();
                            saveParams.GETAuto = r;
                            saveParams.ImageData = this.NewImplementImage;
                            this._subscriptions.push(this._implementService.SaveImplementImage(saveParams).subscribe(r => {
                                if (r) {
                                    this.loadImplementImage();
                                }
                            }));
                        } else {
                            this.saveDefaultImage();
                        }
                    }
                }

                // Record the setup event.
                var params1 = this.createImplementDetailParams();
                params1.Details.Id = r;
                params1.EquipmentId = this.selectedEquipment ? this.selectedEquipment : 0;
                console.log("details,", params1)
                // this._implementService.CreateImplementSetupEvent(params1).subscribe(r => {
                //     if (r < 0) {
                //         this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
                //     }
                // });

            });
            this.currentStep = 1;
        });

    }

    saveDefaultImage() {
        var defaultImageType = 0;
        var implementType = this.implementTypeList.find(f => f.TemplateId == this.selectedImplementType);

        if (this.selectedImplement <= 0) {
            return;
        }

        this._implementService.SaveDefaultImplementImage(this.selectedImplement).subscribe(r => {
            if (r.m_Item1) {
                this.loadImplementImage();
            }
        });
    }

    saveImplement() {
        var validationResult3 = this.step1Validation();
        console.log("validationResult3", validationResult3)
        if (validationResult3.Status) {
            this.validateSmuAndLtd().then(v => {
                console.log(v, "status")
                if (v.Status) {
                    this.currentStep = 1;
                } else {
                    this.step1ErrorHandler(v.Message);
                }
            }).catch(err => {
                this.currentStep = 0;
                console.log(err);
            });
        }

        else {
            this.step1ErrorHandler(validationResult3.Message);
        }

        return
    }

    step1ErrorHandler(message) {
        this.currentStep = 0;
        this.toastr.error(message);
    }

    // CheckModelSelected(){
    //     console.log("this.selectedModels", this.selectedModels)
    //     if( this.selectedModels!=null){

    //     }else{

    //         var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
    //         validationResult.Status = false;
    //         validationResult.Message = "Please Select Models";
    //         this.step1ErrorHandler(validationResult.Message )  ;
            
    //     }
    
    // }

    goToStep(step: number) {
        switch (step) {
            case 1:
               
                //this.currentStep = 1;// for testing
                this.loadGETComponents();
                this.loadObservationPointTypes();
                this.saveImplement();
                this.loadOLDObservationPointsForImplement();
                this.loadOldGETComponents();
                if (this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_NEW) {
                    this.loadmodelfromEquipment();
                }

                this.unsavedChanges_ComponentSetup = true;
                break;

            case 2:
                if (this.stepThreeIsValid()) {
                    this.saveComponents();
                    this.saveSchemanticImages();
                    this.CheckSelectedImplementCopyFrom();
                    //this.loadSchematicImageList();
                    this.unsavedChanges_OPSetup = true;
                }
                break;
            case 3:
                this.submitChanges();
                this.unsavedChanges_ModelSetup = true;
                break;
        }
    }


    validateAndProcessTab2() {
        this.loadComponentsAndObservationPoints();
        this.currentStep = 2;
    }

    // Submit changes made to measurement points and observation points.
    submitChanges() {
        var valiadateResult = this.validationForComponentsandOPTab3();


        if (valiadateResult.Status) {
            if (this.ismodified) {
                let isChnages = this.checkAnyChnagesHappend();
                console.log("Chack chnages_________", isChnages)
                if (isChnages) {
                    if (this.onlyInA.length > 0) {
                        if (this.onlyInA.length >= 1) {
                            if ((this.cbApplyToOne == true) && (this.cbApplyToAll == true)) {

                                this.toastr.error('Please select only one checkbox to apply these changes');
                                return
                            }
                            else if ((this.cbApplyToAll == false) && (this.cbApplyToOne == false)) {

                                this.toastr.error('Please select whether you want to apply changes to this implement or all instances of this implement');
                                return
                            }
                            else {
                                if (this.cbApplyToAll == true) {
                                    var issaved_1 = this.UpdateChangesinTab3ToAll();
                                    if (issaved_1) {
                                        this.currentStep = 3;
                                        this.toastr.success('Successfully modified all implements.');
                                        //this.currentStep = 3;
                                    }
                                }
                                else {
                                    var issaved_2 = this.UpdateChangesinTab3ToThis();
                                    if (issaved_2) {
                                        this.currentStep = 3;
                                        this.toastr.success('Successfully modified this implement.');

                                    }
                                }
                            }
                        }
                    }
                    else if (this.onlyInA.length == 0) {

                        // this.toastr.warning('Did not identify any changes');
                        this.currentStep = 3;
                        this.haschanges = false
                    }
                }


                else {
                    if (!valiadateResult.Status) {
                        this.toastr.error(valiadateResult.Message);
                    }
                }
            } else {
                if (!valiadateResult.Status) {
                    this.toastr.error(valiadateResult.Message);
                } else {
                    this.currentStep = 3;
                }

            }
        }
    }

    // Validate components.
    validateComponents() {
        var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
        validationResult.Status = true;
        validationResult.Message = "";

        for (var i = 0; i < this.componentList.length; i++) {
            if (this.componentList[i].Name == null || this.componentList[i].Name.trim().length == 0) {
                validationResult.Message = this.pageErrors.ERROR_COMPONENT_NAME_MISSING;
                validationResult.Status = false;
            }
            // if (this.componentList[i].PartNo == null || this.componentList[i].PartNo.trim().length == 0) {
            //     validationResult.Message = this.pageErrors.ERROR_COMPONENT_PART_MISSING;
            //     validationResult.Status = false;
            // }
            // if (this.componentList[i].CompTypeId == null || this.componentList[i].CompTypeId == 0) {
            //     validationResult.Message = this.pageErrors.ERROR_COMPONENT_TYPE_MISSING;
            //     validationResult.Status = false;
            // }
            // if (this.componentList[i].MakeId == null || this.componentList[i].MakeId == 0) {
            //     validationResult.Message = this.pageErrors.ERROR_COMPONENT_MAKE_MISSING;
            //     validationResult.Status = false;
            // }
        }

        return validationResult;
    }

    //loadSchematicImageList
    loadSchematicImageList() {
        this.loadImplementSchematics();
    }


    HasChildImplements: boolean
    //check implement is copyfrom
    CheckSelectedImplementCopyFrom() {
        this._implementService.CheckhasCopyFrom(this.selectedImplement).subscribe(res => {
            console.log("resulttt", res)
            if (res) {
                this.cbApplyToOne = false;
                this.cbApplyToAll = false;
                this.HasChildImplements = true;
            } else {
                this.cbApplyToOne = true;
                this.cbApplyToAll = false;
                this.HasChildImplements = false;
            }
        })
    }
    // Save changes to components.
    saveComponents() {
        var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
        validationResult.Status = true;
        validationResult.Message = "";

        validationResult = this.validateComponents();

        var params: SaveComponentParams = new SaveComponentParams();
        params.ImplementId = this.attachedImplementSelected;
        params.Components = this.componentList;

        if (validationResult.Status) {
            this._implementService.SaveComponents(params).subscribe(r => {
                if (r == false) {
                    this.toastr.error(this.pageErrors.ERROR_SAVING_MP);
                } else {
                    this.validateAndProcessTab2();
                    var params1 = this.createImplementDetailParams();
                    params1.Details.Id = this.attachedImplementSelected;
                    this._implementService.CreateImplementSetupEvent(params1).subscribe(r => {
                        if (r < 0) {
                            this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
                        }
                    });
                }
            });
        } else {
            this.toastr.error(validationResult.Message);
        }
    }

    // Saves any changes made to observation points.
    saveObservationPoints() {
        var params: SaveObservationPointParams = new SaveObservationPointParams();
        params.GetAuto = this.attachedImplementSelected;
        params.ObservationPoints = this.observationPoints;

        this._implementService.SaveObservationPoints(params).subscribe(r => {
            if (r < 0) {
                this.toastr.error(this.pageErrors.ERROR_SAVING_OP);
            } else {
                // Now mark setup as complete.
                this.setupComplete = true;
            }
        })
    }


    // For 'Setup on equipment' ensure that customer, jobsite and equipment selections have been made.
    // For 'Setup in inventory' ensure that customer and jobsite are selected.
    // Otherwise validation fails.
    stepTwoIsValid(): boolean {
        return true;
    }

    stepThreeIsValid(): boolean {
        return true;
    }

    // Navigate back to the previous tab.
    goBackStep(step: number) {
        // Step 1 to Step 0
        if (this.currentStep == 1) {
            if (this.unsavedChanges_ComponentSetup) {
                this.unsavedChanges_ComponentSetup = false;
                this.toastr.warn(this.pageErrors.ERROR_UNSAVED_CHANGES_PREVIOUS_STEP);
            } else {
                this.loadImplementTypes();
                this.currentStep--;
            }
        }

        // Step 2 to step 1
        else if (this.currentStep == 2) {
            if (this.unsavedChanges_OPSetup) {
                this.unsavedChanges_OPSetup = false;
                this.toastr.warn(this.pageErrors.ERROR_UNSAVED_CHANGES_PREVIOUS_STEP_2);
            } else {
                this.loadGETComponents();
                this.unsavedChanges_ComponentSetup = true;
                this.currentStep--;
            }
        }
        else if (this.currentStep == 3) {
            if (this.unsavedChanges_ModelSetup) {
                this.unsavedChanges_ModelSetup = false;
                this.toastr.warn(this.pageErrors.ERROR_UNSAVED_CHANGES_PREVIOUS_STEP_3);
            } else {
                this.loadSchematicImageList();
                this.unsavedChanges_OPSetup = true;
                this.currentStep--;
            }
        }
    }

    // Setup another implement after submitting data.
    navigateToSetupImplements() {
        this._router.navigate(['setup/implement']);
        this.clearAll();
        this.currentStep = 0;
        this.setupComplete = false;
    }

    // Navigate to the dashboard (My Implements) page after finishing setup.
    navigateToMyImplements() {
        window.location.href = 'https://' + this.oldGetUrl + '/GET/MyImplements.aspx?';
    }



    /////////////////////
    //Validate Tab3 ////
    ////////////////////

    validationForComponentsandOPTab3(): ValidationErrorStatus {
        var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
        validationResult.Status = true;
        validationResult.Message = "";

        if (this.observationPoints.length > 0) {
            this.isvalidStep3 = true
            this.observationPoints.forEach(element => {
                if ((element.Name == "") || (element.Name.trim().length < 1)) {
                    validationResult.Status = false;
                    validationResult.Message = "Observation Name cannot be empty";
                }
                if (element.ObservationPointType == 0) {
                    validationResult.Status = false;
                    validationResult.Message = "Observation Type cannot be empty";
                }
                if ((element.NumberOfReadings != 0) && (element.ObservationPointType > 0)) {
                    if ((element.LimitNew == 0 || element.LimitScrap == 0) && (element.ObservationPointType != 3) && ( element.ObservationPointType!=4 ) && (element.ObservationPointType!=5)) {
                        validationResult.Status = false;
                        validationResult.Message = "Limits cannot be empty";
                    }
                    if (element.ObservationPointType == 1) {

                        if (element.NumberOfReadings == 0 || element.NumberOfReadings == null) {
                            if (element.LimitNew != 0 || element.LimitScrap != 0) {
                                validationResult.Status = false;
                                validationResult.Message = "No of Readings can not be empty";
                            }
                        }
                        else {
                            if (element.LimitScrap >= element.LimitNew) {
                                validationResult.Status = false;
                                validationResult.Message = "Limit New cannot be lower than Used Limit";
                            }
                            if (element.LimitScrap == 0 && element.LimitNew > 0) {
                                validationResult.Status = true;
                            }
                        }
                    }
                    else if (element.ObservationPointType == 2) {
                        if (element.NumberOfReadings == 0 || element.NumberOfReadings == null) {
                            if (element.LimitNew != 0 || element.LimitScrap != 0) {
                                validationResult.Status = false;
                                validationResult.Message = "No of Readings can not be empty";
                            }
                        }
                        else {
                            if (element.LimitNew >= element.LimitScrap) {
                                validationResult.Status = false;
                                validationResult.Message = "Used Limit cannot be lower than New Limit";
                            }
                            if (element.LimitNew == 0 && element.LimitScrap > 0) {
                                validationResult.Status = true;
                            }
                        }
                    }
                    else if (element.ObservationPointType == 3) {
                        // if (element.NumberOfReadings == 0 || element.NumberOfReadings == null) {
                        //     validationResult.Status = false;
                        //     validationResult.Message = "No of Readings can not be empty.";
                        // }
                        if (element.NumberOfReadings > 1) {
                            console.log("Eval", element.LimitNew, element.LimitScrap, element.NumberOfReadings)
                            validationResult.Status = false;
                            validationResult.Message = "Observation Points of type Eval may have 1 reading."
                        }
                        else if (element.LimitNew > 0 || element.LimitScrap > 0) {
                            console.log("Eval", element.LimitNew, element.LimitScrap, element.NumberOfReadings)
                            validationResult.Status = false;
                            validationResult.Message = "Observation Points of type Eval may not have limits.";
                        }
                    }
                }
                else if ((element.NumberOfReadings == 0 || element.NumberOfReadings == null) && element.ObservationPointType != 3) {
                    validationResult.Status = false;
                    validationResult.Message = "No of Readings can not be empty.";
                }
            });
        }

        return validationResult;
    }

    //update observation to the only selected implement
    UpdateChangesinTab3ToThis(): boolean {
        for (var i = 0; i < this.onlyInA.length; i++) {
            var saveParams: UpdateObservationPointModal = new UpdateObservationPointModal();
            saveParams.Name = this.onlyInA[i].Name;
            saveParams.ObservationList = this.onlyInA[i].ObservationListIds;
            saveParams.OPTypeId = this.onlyInA[i].ObservationPointType;
            saveParams.NoOfReadings = this.onlyInA[i].NumberOfReadings;
            saveParams.LimitsNew = this.onlyInA[i].LimitNew;
            saveParams.LimitsScrap = this.onlyInA[i].LimitScrap;
            saveParams.ID = this.onlyInA[i].Id;
            saveParams.ComponentID = this.onlyInA[i].ComponentId;
            saveParams.isApplytoAll = this.cbApplyToAll;
            saveParams.IsActive = this.onlyInA[i].Active;
            saveParams.ImplementId = this.selectedImplement;
            saveParams.QName=this.onlyInA[i].QName;
            saveParams.QDesc=this.onlyInA[i].QDesc;
            saveParams.LimitRange= this.onlyInA[i].LimitRange;
            saveParams.Measurement= this.onlyInA[i].Measurement;


            this._implementService.UpdateObservationPointForThisImpl(saveParams).subscribe((result: any) => {
                if (result > 0) {
                    let savedtothisSucess = true
                    return savedtothisSucess;
                }

            });
        }
        this.currentStep = 3;
        return true;
    }
    //update the observation to all the implements
    savedallSucess: boolean = false

    UpdateChangesinTab3ToAll(): boolean {

        console.log("this.onlyInA________", this.onlyInA)
        if (this.onlyInA.length > 0) {
            for (var i = 0; i < this.onlyInA.length; i++) {
                var saveParams: UpdateObservationPointModal = new UpdateObservationPointModal();
                saveParams.Name = this.onlyInA[i].Name;
                saveParams.ObservationList = this.onlyInA[i].ObservationListIds;
                saveParams.OPTypeId = this.onlyInA[i].ObservationPointType;
                saveParams.NoOfReadings = this.onlyInA[i].NumberOfReadings;
                saveParams.LimitsNew = this.onlyInA[i].LimitNew;
                saveParams.LimitsScrap = this.onlyInA[i].LimitScrap;
                saveParams.ID = this.onlyInA[i].Id;
                saveParams.ComponentID = this.onlyInA[i].ComponentId;
                saveParams.isApplytoAll = this.cbApplyToAll;
                saveParams.IsActive = this.onlyInA[i].Active;
                saveParams.ImplementId = this.selectedImplement;
                saveParams.QName = this.onlyInA[i].QName;
                saveParams.QDesc = this.onlyInA[i].QDesc;

                console.log("saveParams11111", saveParams)
                this._implementService.UpdateObservationPointForAll(saveParams).subscribe((result: any) => {
                    let savedsucess = result;
                    if (result > 0) {
                        return this.savedallSucess = true
                    }
                    else {
                        return this.savedallSucess = false
                    }
                });
            }

        } else {
            console.log("saveParams22222", saveParams)
            var saveParams: UpdateObservationPointModal = new UpdateObservationPointModal();
            saveParams.isApplytoAll = this.cbApplyToAll;
            saveParams.ImplementId = this.selectedImplement;
            this._implementService.UpdateObservationPointForAll(saveParams).subscribe((result: any) => {
                let savedsucess = result;
                if (result > 0) {
                    return this.savedallSucess = true
                }
                else {
                    return this.savedallSucess = false
                }
            });
        }
        this.currentStep = 3;
        return this.savedallSucess;

    }

    checkValueAll(checked) {
        this.AllChecked = checked;
    }
    checkValueOne(checked) {

        this.OneChecked = checked;
    }
    //identify changes to the step three table
    checkAnyChnagesHappend(): boolean {
        var result = true
        this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe((r: any) => {
            this.observationPointsOld = r;
            // console.log("this.OldObservationPoints",this.OldObservationPoints)
            // console.log("this.OldComponentList",this.OldComponentList)
            // console.log("this.observationPoints",this.observationPoints)

            if (this.OldObservationPoints != null) {
                this.onlyInA = this.observationPoints.filter(this.comparer(this.OldObservationPoints));

                if (this.onlyInA.length >= 1) {
                    this.haschanges = true
                    return result = true
                }
                else {
                    this.haschanges = false
                    return result = false
                }
            }

        });
        return result;
    }
    //check changes in mouseover in submit button
    CheckChanges() {
        this.checkAnyChnagesHappend();
    }

    //get differnce in between two arrays
    comparer(otherArray) {
        return function (current) {
            return otherArray.filter(function (other) {
                return other.Name == current.Name
                    && other.NumberOfReadings == current.NumberOfReadings
                    && other.ObservationPointType == current.ObservationPointType
                    && other.LimitNew == current.LimitNew
                    && other.LimitScrap == current.LimitScrap
                    && other.LimitRange == current.LimitRange
                    && other.Measurement == current.Measurement
                    && other.Active == current.Active
                    && other.ObservationListIds.length == current.ObservationListIds.length
                    && other.QName == current.QName
                    && other.QDesc == current.QDesc
                    && (other.ObservationListIds.map((i, index) => {
                        current.ObservationListIds[index] == other.ObservationListIds[index]
                    }))

            }).length == 0;
        }
    }



    checkExistingOP(val) {
        let count = 0
        if (val.trim().length < 1 || val == "") {
            this.toastr.error('The Observation name cannot be empty');
            //this.isvalidStep3 = false
            // return
        }
        this.observationPoints.map(x => {
            if (x.Name.toLowerCase() == val.toLowerCase()) {
                count = count + 1;
            }

        })
        if (count > 1) {
            this.toastr.error('This Observation name already exists!');
            //this.isvalidStep3 = false
            //return
        }
    }



    returnIndexOfItem(id, isNew) {
        for (var i = 0; i < this.schematicList.length; i++) {
            var x = this.schematicList[i];
            if (x.Id == id && x.IsNewImage == isNew) {
                return i;
            }
        }

        return -1;
    }

    deleteimage(id, isNew, array) {
        if (array.length == 0) {
            if (isNew) {
                var index = this.returnIndexOfItem(id, isNew);
                if (index >= 0) {
                    this.schematicList.splice(index, 1);
                }
            } else {
                this._implementService.DeleteImplementSchematicImage(id, this.selectedImplement).subscribe(r => {
                    if (r) {
                        var index = this.returnIndexOfItem(id, isNew);
                        if (index >= 0) {
                            this.schematicList.splice(index, 1);
                        }
                    } else {
                        this.toastr.error("Unable to delete schematic!");
                    }
                });
            }

        }
        if (array.length > 0) {
            this.toastr.error('This schematic currently has Observation points allocated!');
        }
    }

    ValidateNumberInputs(e) {
        if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 110 || e.keyCode == 190 || e.keyCode == 46) {
            return true;
        }
        return false;
    }

    //upload question Imgae


    //uplaod OPQuestion Image

    selectedFile: File
    ModelImage_fromPC: string
    QuestionImage: string
    onSelectOPQuestionImage(event: any, id: number) {
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();
            this.selectedFile = event.target.files[0];
            reader.onloadend = (e) => {
                this.uploadPhoto(reader.result as string, id);

            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    uploadPhoto(newPhoto: string, ID: number) {
        this.ModelImage_fromPC = newPhoto.split(",")[1];

        var saveParams: SaveQuestionImageParams = new SaveQuestionImageParams();
        saveParams.ObservationPointId = ID;
        saveParams.ImageData = this.ModelImage_fromPC;

        this._subscriptions.push(this._implementService.SaveQuestionImage(saveParams).subscribe(r => {
            if (r) {
                this.observationPoints.filter(x => {
                    if (x.Id == ID) {
                        x.QuestionImage = this.ModelImage_fromPC;
                        x.IsNewImage = true;
                        this.toastr.success("Uploaded successfully")
                    }
                })
            }
        }));


    }

    sanitize(image: string) {
        return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
    }

    //end upload
    deleteQuestionimage(OP_ID: number, IsNew: boolean) {
        var saveParams: SaveQuestionImageParams = new SaveQuestionImageParams();
        saveParams.ObservationPointId = OP_ID;
        this._subscriptions.push(this._implementService.DeleteQuestionImage(saveParams).subscribe(r => {
            if (r) {
                this.observationPoints.filter(x => {
                    if (x.Id == OP_ID) {
                        x.QuestionImage = "";
                    }
                })
                this.toastr.success("Deleted successfully")
            }
        }));



    }

    LoadModels(){
        this.selectedModels=null;
        var params: ModelSelectionFilter = {
            Families: this.selectedFamily,
            Makes: this.selectedMakes
        }
        //console.log("parameters",params)
        this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
            if (r) {
                this.modelList_ = r;

            }
        });
    }

    /////////////////////////
    //////TAB 4////////////
    /////////////////
    availablemodelList: GenericIdName[] = [];

    loadAvailableModelList() {
        this.modelList = null

        // console.log("this.filteredFamilyList", this.filteredFamilyList,this.selectedFamilyList)
        //console.log("this.filteredMakeList", this.filteredMakeList, this.selectedMakeList)
        if (this.filteredFamilyList.length > 0) {
            this.filteredFamilyList.map(x => {

                this.selectedFamilyList.push(x.Id);


                // this.selectedFamilyList.map(y => {
                //     if (y != x.Id) {
                //         this.selectedFamilyList.push(x.Id);
                //     }
                // })
            })
        } else {
            this.selectedFamilyList = [];
        }

        if (this.filteredMakeList.length > 0) {
            this.filteredMakeList.map(x => {
                this.selectedMakeList.push(x.Id);

                // this.selectedMakeList.map(y => {
                //     if (y != x.Id) {
                //         this.selectedMakeList.push(x.Id);
                //     }
                // })
            })
        }
        else {
            this.selectedMakeList = [];
        }

        var params: ModelSelectionFilter = {
            Families: this.selectedFamilyList,
            Makes: this.selectedMakeList
        }
        //console.log("parameters",params)
        this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
            if (r) {
                this.availablemodelList = r;
                this.source = this.availablemodelList;

            }
        });

        //console.log(this.source)
    }

    filteredMakeList: GenericIdName[] = [];
    removable = true;
    filteredFamilyList: FamilyList[] = [];

    onSelectionMake(e, v) {
        // console.log("selected", v)
        for (let a of v) {

            let isequal = this.makeList.find(x => x.Id == a.value);
            if (isequal != null) {
                let has = this.filteredMakeList.find(y => y.Id == isequal.Id);
                if (has != null) {
                }
                else {
                    // var newMake = new GenericIdName();
                    // newMake.Id = isequal.Id
                    this.filteredMakeList.push(isequal);
                    this.makeList = this.makeList.filter(x => x.Id != a.value)
                }
                this.loadAvailableModelList();
            }
            // this.makeList.map(x => {
            //     if (x.Id == a.value) {
            //         let has = this.filteredMakeList.find(y => y.Id == x.Id);
            //         if (has != null) {
            //         }
            //         else {
            //             this.filteredMakeList.push(x);
            //             this.makeList = this.makeList.filter(x => x.Id !=a.value)
            //         }
            //     }
            //     this.loadAvailableModelList();
            // });

        }


    }



    removeMake(item: GenericIdName): void {
        const index = this.filteredMakeList.indexOf(item);

        if (index >= 0) {
            this.filteredMakeList.splice(index, 1);
            this.makeList.push(item);
            this.loadAvailableModelList();
        }

    }


    onSelectionFamily(e, v) {
        for (let a of v) {

            let isequal = this._favouriteDialogService.availableFamilyList.find(x => x.Id == a.value);
            if (isequal != null) {
                let has = this.filteredFamilyList.find(y => y.Id == isequal.Id);
                if (has != null) {
                }
                else {
                    // var newMake = new GenericIdName();
                    // newMake.Id = isequal.Id
                    this.filteredFamilyList.push(isequal);
                    this._favouriteDialogService.availableFamilyList = this._favouriteDialogService.availableFamilyList.filter(x => x.Id != a.value)
                }
                this.loadAvailableModelList();
            }


            // this._favouriteDialogService.availableFamilyList.map(x => {
            //     if (x.Id == a.value) {
            //         let has = this.filteredFamilyList.find(y => y.Id == x.Id);
            //         if (has != null) {
            //         }
            //         else {
            //             this.filteredFamilyList.push(x);
            //             this._favouriteDialogService.availableFamilyList = this._favouriteDialogService.availableFamilyList.filter(x => x.Id != a.value)
            //         }
            //     }
            //     this.loadAvailableModelList();
            // });

        }


    }

    removeFamily(item: FamilyList): void {
        const index = this.filteredFamilyList.indexOf(item);

        if (index >= 0) {
            this.filteredFamilyList.splice(index, 1);
            this._favouriteDialogService.availableFamilyList.push(item);
            this.loadAvailableModelList();
        }

    }

    async mapArry() {

        if(this.equipmentOrInventory!='3'){
            const inspection_record = this.target.map(x => {
                this.modelselected.push(x.Id);
                return x.Id;
            });
            console.log('middle check')
            await Promise.all(inspection_record).then(res => {
                console.log('res', res)
                this.SaveModels(res)
            })
        }

        if(this.equipmentOrInventory=='3'){
            this.SaveModelsTemplate(this.selectedModels);
        }
        
    };

    modelselected: number[] = [];
    SaveModels(selectedModels: number[]): ValidationErrorStatus {
        var result: ValidationErrorStatus = {
            Status: false,
            Message: ""
        };

        var params: SaveModeltParams = new SaveModeltParams();
        params.ImplementId = this.selectedImplementType;
        params.ModelList = selectedModels//this.modelselected;
        params.Get_auto = this.selectedImplement
        this._implementService.SaveImplementModelDetails(params).subscribe(r => {
            if (r == false) {
                result.Status = false;
                result.Message = "Please select Model";
                this.toastr.error(result.Message)
               // return result;
            }
            else {
                result.Status = true;
                result.Message = "";
                this._router.navigate(['/implementdetails', this.selectedImplement]);
            }
        });

        return result;
    }

    SaveModelsTemplate(selectedModels: number[]): ValidationErrorStatus {
        var result: ValidationErrorStatus = {
            Status: false,
            Message: ""
        };

        var params: SaveModeltParams = new SaveModeltParams();
        params.ImplementId = this.selectedImplementType;
        params.ModelList = selectedModels//this.modelselected;
        params.Get_auto = this.selectedImplement


        console.log("Inventoey mdels", params)
        this._implementService.SaveImplementModelDetails(params).subscribe(r => {
            if (r == false) {
                result.Status = false;
                result.Message = this.pageErrors.ERROR_SAVING_CHANGES;
            }
            else {
                result.Status = true;
                result.Message = "";
                this._router.navigate(['/implementdetails', this.selectedImplement]);
            }
        });

        return result;
    }

    isCriticalChangedevent(event){
        console.log("1", event.checked)
        console.log("1", this.isGETCritical)
        console.log("1", this.newComponentCritical)
        if(event.checked==true && this.isGETCritical==true )
     {
         
         this.isGETCritical=false
     }
    

    }
    isGETChangedevent(event)
    {
        console.log("2", event.checked)
        console.log("2", this.newComponentCritical)
        console.log("2", this.isGETCritical)
        if(event.checked==true && this.newComponentCritical==true ){
           
            this.newComponentCritical=false
        }
    }



    getColorCodes(){
        this._implementService.getColorCodes().subscribe(res=>{
            this.colorCodeList=res
  
        })
    }
    

}



/////////////////
// File Reader //
/////////////////
export interface FileReaderEventTarget extends EventTarget {
    result: string;
}

export interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}


